import { formatDate } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators
} from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { JsonAdvancedSearchResult, NodeServiceResourceService } from '@psnb/nwt-api';
import { ImageMetaDataUpdateRequest, IP, Node, PowerSupply, UserDetails } from '@psnb/psnb-api';
import {
  AuthService,
  BatteryHeaterMatService,
  CabinetVendorService,
  CommunityServedService,
  NextGenNodeService,
  PowerSupplyModelsService,
  PowerSupplyService,
  PowerSupplyTransponderModelService,
  PowerSupplyVendorService,
  PSConfigService,
  PsImagesService,
  PSTransponderVendorsModelsService,
  TransponderVendorService
} from '@psnb/services';
import { BottomSheetComponent } from 'desktop/power-supply/bottom-sheet/bottom-sheet.component';
import { DatesharedService } from 'desktop/power-supply/power-supply-edit/dateshared.service';
import { PowerSupplyMoveErrorDialog } from 'desktop/power-supply/power-supply-move/power-supply-move-error-dialog';
import { ValidationErrorDialog } from 'desktop/power-supply/Upload/power-supply-bulk-upload/validation-error-dialog';
import { Observable } from 'rxjs';
import { debounceTime, map, shareReplay, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../common/common.service';
import { UploadDialog } from '../../common/message-dialog/upload-dialog';
import { MessageService } from '../message.service';
import {
  PowerSupplyEditSupplysfpComponent
} from '../power-supply-apu/power-supply-edit-supplysfp/power-supply-edit-supplysfp';
import { PowerSupplyCreatedDialog } from './power-supply-created-dialog.component';
import { PowerSupplyNameDialog } from './power-supply-name-dialog.component';
import { PowerSupplyNameNetConnectDialog } from './power-supply-name-netconnect-dialog.component';
import { BatteryDateCodeValidation } from './Validations/battery.datecode.validator';
import { GpsLatitudeValidation } from './Validations/gps.latitude.validator';
import { GpsLongitudeValidation } from './Validations/gps.longitude.validator';
import { MACPlaceholderValidation } from './Validations/mac.placeholder.validator';
import { PowerSupplyNumValidation } from './Validations/powersupply.number.validator';
import { TransponderFormValidator } from './Validations/transponder.form.validator';

export class ParentErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = !!(form && form.submitted);
    const controlTouched = !!(control && (control.dirty || control.touched));
    const controlInvalid = !!(control && control.invalid);
    const parentInvalid = !!(control && control.parent && control.parent.invalid && (control.parent.dirty || control.parent.touched));
    return isSubmitted || (controlTouched && (controlInvalid || parentInvalid));
  }
}
@Injectable({
  providedIn: 'root'
})
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'nwt-power-supply-create',
  templateUrl: './power-supply-create.component.html',
  styleUrls: ['./power-supply-create.component.scss']
})

export class PowerSupplyCreateComponent implements OnInit, OnDestroy {
  public zoomLevel: number = 1;
  private powerSupplyNameNetConnectDialog: MatDialogRef<PowerSupplyNameNetConnectDialog>;
  public userDetails: UserDetails;
  photoInfoForm: FormGroup;
  locationInfoForm: FormGroup;
  transponderInfoForm: FormGroup;
  lastVisitInfoForm: FormGroup;
  batteryInfoForm: FormGroup;
  nodesForm: FormGroup;
  batteryStringForm: FormGroup;
  batteryBatteryForm: FormGroup;
  transponderVendorControl = new FormControl();
  showPowerSupplyModel: boolean = true;
  showPowerSupplyType9360: boolean = false;
  showPSNumberSelect: boolean = true;
  showPSNumberInput: boolean = false;
  filterNodeOptions: Observable<JsonAdvancedSearchResult[]>[] = [];
  split: string[] = [];
  powerSupplyName = '';
  powerSupplyAlertProfile = '';
  activeMacAddress = '';
  nodesServed: string = '';
  prevNodes: any = 0;
  min: number;
  max: number;
  batteryGroup: any;
  nodeValues: Array<string> = new Array<string>(33);
  nodeName: string = '';
  node2: string = '';
  node3: string = '';
  node4: string = '';
  node5: string = '';
  node6: string = '';
  node7: string = '';
  node8: string = '';
  node9: string = '';
  node10: string = '';
  node11: string = '';
  node12: string = '';
  node13: string = '';
  node14: string = '';
  node15: string = '';
  node16: string = '';
  node17: string = '';
  node18: string = '';
  node19: string = '';
  node20: string = '';
  node21: string = '';
  node22: string = '';
  node23: string = '';
  node24: string = '';
  node25: string = '';
  node26: string = '';
  node27: string = '';
  node28: string = '';
  node29: string = '';
  node30: string = '';
  node31: string = '';
  node32: string = '';
  poleNumber: string = '';
  houseNumber: string = '';
  street: string = '';
  crossStreet: string = '';
  city: string = '';
  state: string = '';
  region: string = '';
  hierarchyPath: string = '';
  nodeId: number = 0;
  showProgressBar: boolean = false;
  disableSaveButton: boolean = false;
  showProgressspinner: boolean = false;
  showForms: boolean = false;
  showLoading: boolean = false;
  mapNumber: string = '';
  gpsLatitude: number= 0;
  gpsLongitude: number= 0;
  desc: string = '';
  powersNode: string = '';
  businessPartnerRestriction: string = '';
  priority: string = '';
  basePowerSupplyName: string = '';
  userName: string = '';
  noOfBatteriesFused: Array<number>;
  sysContact: string = "POLE#" + this.poleNumber + "_" + this.houseNumber + " " + this.street + "_" + this.city + ", " + this.state;
  sysLocation: string = "NODES#" + this.nodeName + "-" + this.node2 + "-" + this.node3 + "-" + this.node4 + "-" + this.node5 + "_MAP#" + this.mapNumber + "_LAT#" + this.gpsLatitude + "_LONG#" + this.gpsLongitude + "_DETAILS#" + this.desc + "_RUNS NODE#" + this.powersNode + "_PRIORITY " + this.priority;
  private powerSupplyNameDialog: MatDialogRef<PowerSupplyNameDialog>;
  private powerSupplyCreatedDialog: MatDialogRef<PowerSupplyCreatedDialog>;
  private powerSupplyMoveErrorDialog: MatDialogRef<PowerSupplyMoveErrorDialog>;
  private uploadDialog: MatDialogRef<UploadDialog>;
  private validationErrorDialog: MatDialogRef<ValidationErrorDialog>;
  private sfpsupplyComponent: MatDialogRef<PowerSupplyEditSupplysfpComponent>;
  private supplyComponent: MatDialogRef<PowerSupplyCreateComponent>;
  pullTransponderButton: boolean = true;
  asterisk: string = '';
  originalMac: string = '';
  noOfBatteries: number = 0;
  regionId: number = 0;
  selectedPSType: string = 'hint';
  prvString: any = 0;
  prvBattery: any = 0;
  communityServed: string = '';
  validateFN: boolean = false;
  division: string = '';
  nodeIdValues: Array<number> = new Array<number>(33);
  node2_id: number;
  node3_id: number;
  node4_id: number;
  node5_id: number;
  node6_id: number;
  node7_id: number;
  node8_id: number;
  node9_id: number;
  node10_id: number;
  node11_id: number;
  node12_id: number;
  node13_id: number;
  node14_id: number;
  node15_id: number;
  node16_id: number;
  node17_id: number;
  node18_id: number;
  node19_id: number;
  node20_id: number;
  node21_id: number;
  node22_id: number;
  node23_id: number;
  node24_id: number;
  node25_id: number;
  node26_id: number;
  node27_id: number;
  node28_id: number;
  node29_id: number;
  node30_id: number;
  node31_id: number;
  node32_id: number;
  powerCompanyFinderUrl: string;
  interval;
  url: any = null;
  file: File;
  fileName: string = '';
  filearray: any = [];
  filecategoryarray: any = [];
  triageId: any;
  powerSupplyId: number = 0;
  detailedImage: any = null;
  fileblobarray = [];
  triage: any;
  permissionValue:any;
  showMeter: boolean = false;
  visitStatusvalue: any = [];
  followUpReasons: any = [];
  CleanDustDirtFromEnclosure: any = [];
  TightenAllEnclosureHardwares: any = [];
  InspectWireHarnessesConnectors: any = [];
  InspectBatteryTemperatureProbes: any = [];
  //TypeofVisitInhouse: any = [];
  //TypeofVisitBP: any = [];
  XOCTransponderVerifications: any = [];
  MeterPanCondition: any = [];
  coRiserCondition: any = [];
  batteryHeaterMatType: any = [];
  snowSheildOptionss: any = [];
  seizureScres: any = [];
  powerSupplyIDLegibilitis: any = [];
  lampCheckOptionValues: any = [];
  checkCircuitBreakOptionValues: any = [];
  cabinetInspectionvalues: any = [];
  cabinetLockOptionvalues: any = [];
  checkGroundConnectionvalues: any = [];
  batteryStringFuses: any = [];
  securityBarOptionvalues: any = [];
  tamperInstalledvalue: any = [];
  checkLAPsvalue: any = [];
  cabinetVendorvalues: any = [];
  batteryCapacitievalues: any = [];
  operatingLightvalues: any = [];
  followUpActionvalue: any = [];
  surgeArrestorInputvalues: any = [];
  outputSurgeArrestorvalues: any = [];
  coaxOptionvalues: any = [];
  ACIOptionvalues: any = [];
  LRIOptionvalues: any = [];
  PsEditFieldsMetadata:any;
  isLoadingdata:boolean = false;
  telemetryThresholdProfileData : Array<string> = [];
  validationFlag:boolean = true;
  userpermissions:any;
  nwtTeamData:any;
  visitTypesinhouse: any[] = [];
  visitTypesbp: any[] = [];
  scanSerialNum:any;
  scanBatteryModel:any;
  scanManufactureDate:any;
  scanCurrentDate: any;
  parallelBatteries: String = null;
  parallel: String = "Parallel";
  lionBat: String = "1LionBMS";
  parallelBatt: boolean =  false;
  ins_date: string;
  atOneChecked: boolean;
  isCheckedCheck: boolean;
  public scannerEnabled: Array<any> = [];
  public information: string = "";
  mac_address = '';
  remcolon = '';
  searchTerm: FormControl = new FormControl();
  macSearchResult: PowerSupply[] = [];
  activeMacAddresscopy: any;
  submitFlag: boolean;
  showsfp:boolean = false;
  sfpMAC: any;
  enablephotoStatus: boolean = true;
  zoomFlag: Array<any> = [];
  constructor(private fb: FormBuilder,
    private datesharedService: DatesharedService,
    private authService: AuthService,
    private powerSupplyService: PowerSupplyService,
    private existingMacValidator: MACPlaceholderValidation,
    private nodeService: NodeServiceResourceService,
    private ref: ChangeDetectorRef,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private transponderModelService: PowerSupplyTransponderModelService,
    private powerSupplyVendorService: PowerSupplyVendorService,
    private transponderVendorService: TransponderVendorService,
    private powerSupplyModelsService: PowerSupplyModelsService,
    private nextGenNodeService: NextGenNodeService,
    private communityServedService: CommunityServedService,
    private batteryHeaterMatService: BatteryHeaterMatService,
    private cabinetVendorService: CabinetVendorService,
    private bottomSheet: MatBottomSheet,
    private data: MessageService,
    private commonService: CommonService,
    private psImagesService: PsImagesService,
    private msalService: MsalService,
    private psConfigService: PSConfigService,
    private transponderVendorsModelsService: PSTransponderVendorsModelsService,
  ) {
    this.showProgressBar = true;
    this.route.queryParams
      .subscribe(params => {
        this.nodeId = params['nodeId'];
      });

    localStorage.removeItem('powerSupplySfp');

  }
  createcurrSub;
  permissionlevel(level){
    if(level === CommonService.DISABLED) {
      return 1;
    } else if(level === CommonService.ENABLED){
      return 0;
    } else {
      return 2;
    }
  }
  ngOnInit() {
    //this.userpermissions = this.authService.getDecryptConfig
    this.userpermissions = JSON.parse(localStorage.getItem('user-permissions'));
    if (this.userpermissions=='' || !this.authService.isAuthorizedPSNBUser) {
      this.router.navigate(['/unauthorized']);
    }
    for (let element of this.userpermissions) {
      if (element.category === CommonService.SEARCHBYNODE && element.functionality === CommonService.CREATEPS && element.permission != CommonService.ENABLED) {
        this.router.navigate(['/pageunauthorized']);
        return;
      }
    }
    this.userDetails = JSON.parse(localStorage['user-details']);
    if (this.userDetails.permissions.includes('{1091}')) {
      this.permissionValue = true;
    }else{
      this.permissionValue = false;
    }


    //common save
    this.createcurrSub = this.data.MessageCreateSave.subscribe((data) => {
      if (data['iscreatesubmit']) {
        this.create();
      }
    })

    this.locationInfoForm = this.fb.group({
      locationInfoFormInput: [],
    })

    //this.interval = setInterval(() => this.FormStatusChanges(), 100);
    const message = `PowerSupply Create for Node Id: ${this.nodeId}`;
    const activity = 'PowerSupply Create';
    this.commonService.loggerPost(message, activity, 3);
    this.regionId = 0;
    this.powerCompanyFinderUrl = environment.powerCompanyFinderUrl;
    this.getImageDetails();
    this.powerSupplyService.getPSNameAndRegion(this.nodeId)
      .subscribe(result => {
        if (result !== null) {
          this.region = result.regionName;
          this.hierarchyPath = result.hierarchyPath;
          if (this.hierarchyPath.includes('Central Div')) this.division = 'Central Div';
          if (this.hierarchyPath.includes('Northeast Div')) this.division = 'Northeast Div';
          if (this.hierarchyPath.includes('West Div')) this.division = 'West Div';
          this.nodeName = result.nodeName;
          //calling the nwt team api
          if(this.nodeName != '' || this.nodeName != null){
            this.powerSupplyService.getNWTTeams(this.nodeName,this.state).subscribe(resultdata => {
              this.nwtTeamData = resultdata['nwtTeam'];
              this.locationInfoForm.controls['nwtTeam'].patchValue(this.nwtTeamData);
            });
          }
          this.powerSupplyName = result.powerSupplyName;
          this.basePowerSupplyName = result.powerSupplyName;
          this.regionId = result.regionId;
          if (this.communityServedService.communityServed != null || this.communityServedService.communityServed != undefined) {
            this.communityServed = this.communityServedService.communityServed;
          }
          //this.transponderModelService.getTransponderModelsByRootId(this.regionId).subscribe(result => {
          this.transponderVendorsModelsService.getTransponderModelName().subscribe(result => {
            //result.forEach(res => this.transponderModels.push(res.modelName));
            result.forEach(res => this.transponderModels.push(res));
          });
          this.powerSupplyVendorService.getPowerSupplyVendorsByRootId(this.regionId).subscribe(result => {
            result.forEach(res => this.powerCompanies.push(res.vendorName));
          });
          this.powerSupplyService.getStatesByRootId(this.regionId).subscribe(result => {
            result.forEach(res => this.states.push(res.name));
          });
          //this.transponderVendorService.getTransponderVendorsByRootId(this.regionId).subscribe(result => {
          this.transponderVendorsModelsService.getTransponderVendorName().subscribe(result => {
            //result.forEach(res => this.transponderVendors.push(res.vendorName));
            result.forEach(res => this.transponderVendors.push(res));
          });
          /*this.powerSupplyModelsService.getPowerSupplyModelsByRootId(this.regionId).subscribe(result => {
            result.forEach(res => this.powerSupplyModels.push(res.modelName));
          });*/
          this.powerSupplyModelsService.getPowerSupplyModels().subscribe(result => {
            result.forEach(res => this.powerSupplyModels.push(res.modelName));
          });
          this.getForms()
          this.markAsTouched(this.locationInfoForm);
          this.markAsTouched(this.transponderInfoForm);
          this.markAsTouched(this.batteryInfoForm);
          this.markAsTouched(this.lastVisitInfoForm);
          this.markAsTouched(this.batteryBatteryForm);
          this.markAsTouched(this.batteryStringForm);
          this.ref.detectChanges();
          this.showProgressBar = false;
          this.showProgressspinner = false;
        } else {
          this.getForms()
          this.ref.detectChanges();
        }
      });
    this.userName = this.authService.getUserDetails.userName;
    this.batteryHeaterMatService.getBatteryHeaterMatTypesService().subscribe(res => {
      res.forEach(result => this.batteryHeaterMatTypes.push(result.batteryHeaterMatType));
    });
    this.powerSupplyService.getOutputSurgeArrestorsService().subscribe(res => {
      res.forEach(result => this.outputSurgeArrestors.push(result.name));
    });
    // this.powerSupplyService.getControllerCardTypesService().subscribe(res => {
    //   res.forEach(result => this.cardTypes.push(result.name));
    // });
    this.powerSupplyService.getBatteryTypesService().subscribe(res => {
      res.forEach(result => this.batteryManufactureres.push(result.batteryType));
    });
    // this.powerSupplyService.getBatteryBalancersService().subscribe(res => {
    //   res.forEach(result => this.batteryManagerModels.push(result.balancerModel));
    // });
    // this.powerSupplyService.getEstimatedDesignRuntimesService().subscribe(res => {
    //   res.forEach(result => this.estimates.push(result.name));
    // });
    this.powerSupplyService.getInputSurgeArrestorsService().subscribe(res => {
      res.forEach(result => this.surgeArrestorInputs.push(result.name));
    });
    this.cabinetVendorService.getAllCabinetVendors().subscribe(res => {
      res.forEach(result => this.cabinetVendors.push(result.name));
    });
    this.nextGenNodeService.getAllNextGenNodes().subscribe(result => {
      result.forEach(res => this.nextGenOptions.push(res.nextGenNode));
    });
    this.fieldConfig();
    this.getTelemetryThresholdsAlertProfileData();

    this.powerSupplyService.getStandByOptionsByState(this.state).subscribe(res => {
      res.forEach(result => this.standByOptions.push(result.standbyOptions));
    });

    this.datesharedService.editpssharedsupplyDatadetail$
      .subscribe(supplyData => {
        setTimeout(() => {
        this.transponderInfoForm.controls['sfpMac'].setValue(supplyData);
        });
    });

  }

  SelectAllOk(checked){
    if (checked) {
      this.disableSaveButton = true;
      //this.lastVisitInfoForm.controls["checkAll"].setValidators(Validators.required);
      //this.lastVisitInfoForm.controls["checkAll"].updateValueAndValidity();
    } else {
      this.disableSaveButton = false;
      //this.lastVisitInfoForm.controls["checkAll"].clearValidators();
      //this.lastVisitInfoForm.controls["checkAll"].updateValueAndValidity();
    }
  }

  onChangeIns(event){
    this.ins_date = formatDate(new Date(), 'dd/MM/yyyy', 'en-US');
    if(event.checked){
        this.lastVisitInfoForm.controls['inspectionDate'].setValue('');
        this.lastVisitInfoForm.controls['inspectionDate'].setValue(new Date());
    }else{
      this.lastVisitInfoForm.controls['inspectionDate'].setValue('');
    }
  }

  SortByName(x, y) {
    return ((x == y) ? 0 : ((x > y) ? 1 : -1));
  }
  ngOnDestroy() {
    if(this.createcurrSub)
    this.createcurrSub.unsubscribe();
  }
  fieldConfig(){
      this.PsEditFieldsMetadata = JSON.parse(localStorage['AllPsEditFieldsMetadata']);
      if(this.PsEditFieldsMetadata == null || this.PsEditFieldsMetadata == '') {
        return new Promise( (resolve, reject) => {
        this.psConfigService.getAllPsEditFieldsMetadata().subscribe((res) => {
            this.PsEditFieldsMetadata = res;
            this.getFieldValue();
          });
          resolve('Fetched AllPsEditFieldsMetadata Detail');
        });
      }else{
        this.getFieldValue();
      }

        //sorting json values asc
        //this.visitTypesbp.sort(this.SortByName);
        //this.visitTypesinhouse.sort(this.SortByName);
        this.visitTypesbp.sort(this.SortByName);
        this.visitTypesinhouse.sort(this.SortByName);
        this.visitStatusvalue.sort(this.SortByName);
        this.followUpReasons.sort(this.SortByName);
        this.InspectBatteryTemperatureProbes.sort(this.SortByName);
        this.coRiserCondition.sort(this.SortByName);
        this.snowSheildOptionss.sort(this.SortByName);
        this.seizureScres.sort(this.SortByName);
        this.powerSupplyIDLegibilitis.sort(this.SortByName);
        this.cabinetInspectionvalues.sort(this.SortByName);
        this.cabinetLockOptionvalues.sort(this.SortByName);
        this.securityBarOptionvalues.sort(this.SortByName);
        this.checkGroundConnectionvalues.sort(this.SortByName);
        this.batteryStringFuses.sort(this.SortByName);
        this.tamperInstalledvalue.sort(this.SortByName);
        this.checkLAPsvalue.sort(this.SortByName);
        this.batteryCapacitievalues.sort(this.SortByName);
        this.followUpActionvalue.sort(this.SortByName);
        this.coaxOptionvalues.sort(this.SortByName);
        this.ACIOptionvalues.sort(this.SortByName);
        this.LRIOptionvalues.sort(this.SortByName);
        // this.nodeFeeds.sort(this.SortByName);
        this.UGs.sort(this.SortByName);
        this.nodePowers.sort(this.SortByName);
        this.acctypes.sort(this.SortByName);
        this.businessPartneRestrictions.sort(this.SortByName);
        this.DCReadyDecisions.sort(this.SortByName);
        this.ampOutputRatings.sort(this.SortByName);
        // this.ampRatings.sort(this.SortByName);
        this.outputVoltageRatings.sort(this.SortByName);
        this.inputVoltageRatings.sort(this.SortByName);
        //this.standByOptions.sort(this.SortByName);
        this.numberofBatteries.sort(this.SortByName);
        //this.batterySeparatorPresent.sort(this.SortByName);
        this.batteriesReplaced.sort(this.SortByName);
    }

  getFieldValue() {
      this.PsEditFieldsMetadata.forEach((Itemdata, index) => {
      if (Itemdata['fieldName'] == 'Visit Status') {
        this.visitStatusvalue.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Follow Up Reason Needed') {
        this.followUpReasons.push(Itemdata['value'])
      }
      /*if (Itemdata['fieldName'] == 'Type of Visit - BP') {
        this.TypeofVisitBP.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Type of Visit - Inhouse') {
        this.TypeofVisitInhouse.push(Itemdata['value'])
      }*/
      // if (Itemdata['fieldName'] == 'visitTypes') {
      //   this.visitTypes.push(Itemdata['value'])
      // }
      if (this.permissionValue) {
        if (Itemdata['fieldName'] == 'Type of Visit - Inhouse') {
          this.visitTypesinhouse.push(Itemdata['value'])
        }
      } else {
        if (Itemdata['fieldName'] == 'Type of Visit - BP') {
          this.visitTypesbp.push(Itemdata['value'])
        }
      }
      if (Itemdata['fieldName'] == 'Clean Dust And Dirt From Enclosure') {
        this.CleanDustDirtFromEnclosure.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Meter Pan Condition') {
        this.MeterPanCondition.push(Itemdata['value'])
      }


      if (Itemdata['fieldName'] == 'Cabinet Battery Capacity') {
        this.batteryCapacitievalues.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Check Operating Lights') {
        this.operatingLightvalues.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Follow Up Action Needed') {
        this.followUpActionvalue.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'AC Indicator Green light (ACI)') {
        this.ACIOptionvalues.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Battery String - Fused') {
        this.batteryStringFuses.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Power Co Riser Condition') {
        this.coRiserCondition.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Enclosure Snow Shield') {
        this.snowSheildOptionss.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Check Seizure Screw / Alt Box') {
        this.seizureScres.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Check For 20 Amp Hi-Magnetic Circuit Breaker') {
        this.checkCircuitBreakOptionValues.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Visual Inspection Of Cabinet') {
        this.cabinetInspectionvalues.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Cabinet Locked') {
        this.cabinetLockOptionvalues.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Security Bar Present') {
        this.securityBarOptionvalues.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == "Check LAP's") {
        this.checkLAPsvalue.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Coax TVSS Present') {
        this.coaxOptionvalues.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Tighten All Enclosure Hardware') {
        this.TightenAllEnclosureHardwares.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Inspect Wire Harnesses And Connectors') {
        this.InspectWireHarnessesConnectors.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Inspect Battery Temperature Probes') {
        this.InspectBatteryTemperatureProbes.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Is Power Supply ID Legible') {
        this.powerSupplyIDLegibilitis.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Check Lamps & LEDs') {
        this.lampCheckOptionValues.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Check Ground Connection At Cabinet') {
        this.checkGroundConnectionvalues.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Local and Remote Indicator (LRI)') {
        this.LRIOptionvalues.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'XOC Verified Transponder Operational') {
        this.XOCTransponderVerifications.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Tamper Installed And Functioning') {
        this.tamperInstalledvalue.push(Itemdata['value'])
      }
      // if (Itemdata['fieldName'] == 'Feed Multiple Nodes') {
      //   this.nodeFeeds.push(Itemdata['value'])
      // }
      if (Itemdata['fieldName'] == 'Aerial/UG') {
        this.UGs.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Powers Node') {
        this.nodePowers.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Power Company Account Type') {
        this.acctypes.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Business Partner Restriction') {
        this.businessPartneRestrictions.push(Itemdata['value'])
      }

      /*if (Itemdata['fieldName'] == 'StandBy/Non-StandBy') {
        this.standByOptions.push(Itemdata['value'])
      }*/
      if (Itemdata['fieldName'] == 'AC Input Voltage Rating') {
        this.inputVoltageRatings.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'AC Output Voltage Rating') {
        this.outputVoltageRatings.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Current Amp Rating') {
        this.ampRatings.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Current (Amp Output) Rating') {
        this.ampOutputRatings.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'DC Ready?') {
        this.DCReadyDecisions.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Number Of Batteries') {
        this.numberofBatteries.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Battery Separator Present') {
        //this.batterySeparatorPresent.push(Itemdata['value'])
      }
      if (Itemdata['fieldName'] == 'Were The Batteries Replaced(Yes or No)?') {
        this.batteriesReplaced.push(Itemdata['value'])
      }
      });
    }

    getTelemetryThresholdsAlertProfileData() {
      this.powerSupplyService.getTelemetryThresholdsAlertProfile().subscribe((res) => {
        if(res != null && res.length > 0)
          this.telemetryThresholdProfileData = res;
      });
    }

  onchangeSave() {
    this.locationInfoForm.controls['locationInfoFormInput'].valueChanges.subscribe((formhiddenlocval) => {
      if (formhiddenlocval == false) {
        this.data.createsave('createlocform', "false");
      } else {
        this.data.createsave('createlocform', "true");
      }
    });
  }
  onChangevisitStatus() {
    let event = this.lastVisitInfoForm.value.visitsStatus;
    if (event != 'Complete') {
      // this.lastVisitInfoForm.controls["followUpReasons"].setValidators(Validators.required);
      // this.lastVisitInfoForm.controls["followUpReasons"].updateValueAndValidity();
      //this.lastVisitInfoForm.controls["lastVisitComments"].setValidators(Validators.required);
      //this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
    }
    else {
      // this.lastVisitInfoForm.controls["followUpReasons"].clearValidators();
      // this.lastVisitInfoForm.controls["followUpReasons"].updateValueAndValidity();
      //this.lastVisitInfoForm.controls["lastVisitComments"].clearValidators();
      //this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
    }
    if (event == '' || event == undefined || event == null) {
      // this.lastVisitInfoForm.controls["followUpReasons"].clearValidators();
      // this.lastVisitInfoForm.controls["followUpReasons"].updateValueAndValidity();
      //this.lastVisitInfoForm.controls["lastVisitComments"].clearValidators();
      //this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
    }
  }
  onfollowUpReasons() {
    let event = this.lastVisitInfoForm.value.typeOfVisit;
    if (event != 'Complete') {
      //this.lastVisitInfoForm.controls["lastVisitComments"].setValidators(Validators.required);
      //this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
    }
    else {
      //this.lastVisitInfoForm.controls["lastVisitComments"].clearValidators();
      //this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
    }

    if (event == '' || event == undefined || event == null) {
      //this.lastVisitInfoForm.controls["lastVisitComments"].clearValidators();
      //this.lastVisitInfoForm.controls["lastVisitComments"].updateValueAndValidity();
    }
  }
  /*Function to select the file  - create view File upload */
  getImageDetails() {
    // Get PS Images from Image details
    this.psImagesService.setImages();
    var psImages = this.psImagesService.getImages();
    this.detailedImage = psImages;
  }

  /*Function to select the file  - Edit view File upload */
  onselectFile(event, uploadedId, imagedata): void {
    if (event.target.files[0] !== null && event.target.files[0] !== undefined) {
      this.file = event.target.files[0];
      let fileBlob = null;
      if (this.file !== null && this.file !== undefined) this.fileName = this.file.name;
      var uploadId = event.target.id;
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        this.ref.markForCheck();
        let index = this.detailedImage.indexOf(imagedata);
        imagedata.url = event.target.result;
        this.detailedImage[index] = imagedata;

        if (this.filearray.length > 0) {
          var blob = new Blob([this.file], { type: 'multipart/form-data' });
          fileBlob = new File([blob], this.fileName);
          const existing = this.filearray.find(x => x.id == uploadedId);
          if (existing) {
            let index = this.filearray.indexOf(existing);
            existing.file = this.file;
            existing.filedata = this.fileName;
            existing.fileblob = fileBlob;
            this.filearray[index] = existing;
          } else {
            this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });
          }
        } else {
          var blob = new Blob([this.file], { type: 'multipart/form-data' });
          fileBlob = new File([blob], this.fileName);
          this.filearray.push({ 'id': uploadedId, 'file': this.fileName, 'filedata': this.file, 'fileblob': fileBlob });
        }
      }
      this.psSingleFileUpload(event.target.files[0], uploadedId);
    }
  }

  psSingleFileUpload(file, uploadedId) {
    this.openUploadDialog("Image Uploading..........");
    var uploadvalue = [];
    var categoryUploaded = [];
    var file = file;
    var categoryValue = uploadedId;
    let fileBlob = null;
    let fileName = null;
    let fileblobarray = [];
    if (file !== null && file !== undefined) fileName = file.name;
    var blob = new Blob([file], { type: 'multipart/form-data' });
    fileBlob = new File([blob], fileName);
    categoryUploaded.push(categoryValue);
    let uploadObj = {
      powerSupplyId: 0,
      powerSupplyName: null,
      macAddr: this.transponderInfoForm.value.activeMacAddress,
      nodeId: null,
      createDate: "",
      latestImage: "null",
      fileName: "",
      contentType: "",
      category: categoryValue,
    };
    const uploadBlob = new Blob([JSON.stringify(uploadObj)], { type: 'multipart/form-data' });
    uploadvalue.push(uploadBlob);
    fileblobarray.push(fileBlob);
    var triageId = null;
    if(!this.permissionValue)
      triageId = 0;
    return new Promise((resolve, reject) => {
      this.powerSupplyService.uploadSdsImage('Create', triageId, fileblobarray, uploadvalue)
        .pipe(map(binaryData => binaryData))
        .subscribe(binaryData => {
          resolve(binaryData);
          const message = `PowerSupply Images Uploaded by: ${this.userName} at ${new Date().toISOString()} . Image categories are: ${categoryUploaded}`;
          const activity = 'PowerSupply Image Upload';
          this.commonService.loggerPost(message, activity, 3);
          this.dialog.closeAll();
          this.openErrorDialog("Uploaded Successfully. Please Create Power Supply.");
          //this.openCreatedDialog("Image Uploaded Successfully");
        }, err => {
          reject(err);
          this.showProgressBar = false;
          this.openErrorDialog("Unable to Upload Images");
        });
    });
  }

  /*Function to save the multiple files  - Create Section File Upload*/
  // psFileUpload(powerSupply, psResultmessages) {
  //   this.powerSupplyService.getPowerSupplyByMAC(powerSupply.macAddress)
  //     .subscribe(data => {
  //       if (data.powerSupplyId != null && data.powerSupplyId != 0) {
  //         this.powerSupplyId = data.powerSupplyId;
  //         this.triage = "";
  //         var uploadvalue = [];
  //         var categoryUploaded = [];
  //         for (let i = 0; i < this.filearray.length; i++) {
  //           var categoryValue = this.filearray[i]['id'];
  //           categoryUploaded.push(categoryValue);
  //           let uploadObj = {
  //             powerSupplyId: this.powerSupplyId,
  //             powerSupplyName: powerSupply.powerSupplyName,
  //             macAddr: powerSupply.macAddress,
  //             nodeId: powerSupply.nodeId,
  //             createDate: "",
  //             latestImage: "null",
  //             fileName: "",
  //             contentType: "",
  //             category: categoryValue,
  //           };
  //           const uploadBlob = new Blob([JSON.stringify(uploadObj)], { type: 'multipart/form-data' });
  //           uploadvalue.push(uploadBlob);
  //           this.fileblobarray.push(this.filearray[i]['fileblob']);
  //         }
  //         return new Promise((resolve, reject) => {
  //           this.powerSupplyService.uploadSdsImage(this.triage, this.fileblobarray, uploadvalue)
  //             .pipe(map(binaryData => binaryData))
  //             .subscribe(binaryData => {
  //               resolve(binaryData);
  //               const message = `PowerSupply Images Uploaded by: ${this.userName} at ${new Date().toISOString()} . Image categories are: ${categoryUploaded}`;
  //               const activity = 'PowerSupply Image Upload';
  //               this.commonService.loggerPost(message, activity, 3);
  //               this.showProgressspinner = false;
  //               this.openCreatedDialog(psResultmessages);
  //             }, err => {
  //               reject(err);
  //               this.showProgressspinner = false;
  //               this.openErrorDialog("Unable to Upload Images");
  //             });
  //         });
  //       }
  //     });
  // }

  /*Function to save the multiple file  - create view File upload save for non comcast user*/
  // psFileUploadnoncomcast(triageId, powerSupply, psResultmessages) {
  //   this.powerSupplyId = 0;
  //   this.triageId = triageId;
  //   var uploadvalue = [];
  //   var categoryUploaded = [];
  //   for (let i = 0; i < this.filearray.length; i++) {
  //     var categoryValue = this.filearray[i]['id'];
  //     categoryUploaded.push(categoryValue);
  //     let uploadObj = {
  //       powerSupplyId: this.powerSupplyId,
  //       powerSupplyName: powerSupply.powerSupplyName,
  //       macAddr: powerSupply.macAddress,
  //       nodeId: powerSupply.nodeId,
  //       createDate: "",
  //       latestImage: "null",
  //       fileName: "",
  //       contentType: "",
  //       category: categoryValue,
  //     };
  //     const uploadBlob = new Blob([JSON.stringify(uploadObj)], { type: 'multipart/form-data' });
  //     uploadvalue.push(uploadBlob);
  //     this.fileblobarray.push(this.filearray[i]['fileblob']);
  //   }
  //   return new Promise((resolve, reject) => {
  //     this.powerSupplyService.uploadSdsImage(this.triageId, this.fileblobarray, uploadvalue)
  //       .pipe(map(binaryData => binaryData))
  //       .subscribe(binaryData => {
  //         this.showProgressBar = false;
  //         resolve(binaryData);
  //         const message = `PowerSupply Images Uploaded by: ${this.userName} at ${new Date().toISOString()} . Image categories are: ${categoryUploaded}`;
  //         const activity = 'PowerSupply Image Upload';
  //         this.commonService.loggerPost(message, activity, 3);
  //         this.openCreatedDialog(psResultmessages, true);
  //       }, err => {
  //         this.showProgressBar = false;
  //         reject(err);
  //         this.openErrorDialog("Unable to Upload Images");
  //       });
  //   });
  // }

  markAsTouched(formGroup: any): void {
    Object.keys(formGroup.controls).forEach((key: string) => {
      const abstractControl = formGroup.get(key);
      if (abstractControl instanceof FormGroup || abstractControl instanceof FormArray) {
        this.markAsTouched(abstractControl);
      } else {
        abstractControl.markAsTouched();
        abstractControl.markAsDirty();
      }
    })
  }

  getForms() {
    this.locationInfoForm = this.fb.group({
      locationInfoFormInput: [],
      houseNumberInput: [''],
      street: ['', Validators.required],
      crossStreet: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['',[ Validators.required,Validators.minLength(5),Validators.maxLength(5)]],
      mutliNodes: ['', Validators.required],
      latitude: ['', [Validators.required, GpsLatitudeValidation.ValidateDecimal(this.region), GpsLatitudeValidation.ValidateRange(this.region)]],
      longitude: ['', [Validators.required, GpsLongitudeValidation.ValidateDecimal(this.region), GpsLongitudeValidation.ValidateRange(this.region)]],
      //estimates: [''],
      powerNode: ['', Validators.required],
      spLocDetails: [''],
      areial: ['', Validators.required],
      powerAccountType: [''],
      pole: [''],
      powerCompany: ['', Validators.required],
      companyAccNum: [''],
      companyContact: [''],
      companyWebsite: [''],
      nwtTeam: [{value: '', disabled: true}],
      nitroCompletionDate: [''],
      nitroReasonNotCompleted: [''],
      meter: [''],
      mapPageNumber: [''],
      locationComments: ['', [Validators.maxLength(255)]],
      businessPartnerRestriction: [''],
    });
    this.transponderInfoForm = this.fb.group({
      transponderInfoFormInput: [],
      standByOpts: ['', Validators.required],
      sfpMac: [{ value: this.sfpMAC, disabled: true }],
      activeMacAddress: [{ value: this.activeMacAddress }, [Validators.required, MACPlaceholderValidation.ValidateMac00(), MACPlaceholderValidation.ValidateMac(), this.existingMacValidator.ValidateExistingMac()]],
      prevMacAddress: [{ value: '', disabled: true }],
      ip: ['', Validators.required],
      powerSupplyNum: ['', [Validators.required, PowerSupplyNumValidation.ValidatePowerSupplyNum(this.region)]],
      nextGenNode: [''],
      transponderVendor: ['', [Validators.required]],
      transponderModel: ['', Validators.required],
      powerSupplyModel: [''],
      powerSupplyType9360: [''],
      acInputVoltage: ['', Validators.required],
      acOutputVoltage: ['', Validators.required],
      currentAmp: ['', Validators.required],
      //currentAmpOutput: ['', Validators.required],
      powerSupplyAlertProfile: [{ value: this.powerSupplyAlertProfile, disabled: true }],
      serialNum: [''],
      //controlledCardType: ['', Validators.required],
      dcReady: [''],
      priority: [''],
      egisName: [''],
      externalSensor: [''],
      transponderComments: ['', [Validators.maxLength(255)]]
    }, {
      validator: TransponderFormValidator.ValidateVendorType
    });

    this.onChangeSysLocation();

    this.lastVisitInfoForm = this.fb.group({
      inspectionDate: [],
      typeOfVisit: [''],
      xocVerified: [''],
      visitsStatus: [''],
      followUpReasons: [''],
      mobileno:['', this.permissionValue ? null : Validators.required],
      cleanDust: [''],
      tightenAll: [''],
      inspectWire: [''],
      inspectBattery: [''],
      meterPan: [''],
      powerCo: [''],
      batteryHeaterType: [''],
      batteryHeaterQuantity: [''],
      encloseSnow: [''],
      internalBreaker: [''],
      serviceEntrance: [''],
      receptacleType: [''],
      checkSeizure: [''],
      psIDLegibile: [''],
      checkLamps: [''],
      checkCircuitBreaker: [''],
      visualInspection: [''],
      cabinetLocked: [''],
      securityBar: [''],
      checkGround: [''],
      batteryStringFused1: [''],
      batteryStringFused2: [''],
      batteryStringFused3: [''],
      batteryStringFused4: [''],
      batteryStringFused5: [''],
      batteryStringFused6: [''],
      tamperInstalled: [''],
      checkLaps: [''],
      cabinetVendor: [''],
      cabinetBattery: [''],
      checkOperating: [''],
      followUp: [''],
      inputSurge: [''],
      outputSurge: [''],
      coaxTvss: [''],
      acIndicator: [''],
      lri: [''],
      lastVisitComments: [''],
      checkAll: [''],
    });

    this.batteryInfoForm = this.fb.group({
      batteryInfoFormInput: [],
      numberofBatteries: ['', Validators.required],
      batteriesReplaced: ['', Validators.required],
      //airTemperature: [''],
      batteryManagerModel: ['', Validators.required],
      batteryComments: ['', [Validators.maxLength(255)]]
    });

    this.nodesForm = this.fb.group({
      nodesFormInput: [],
      node: this.fb.array([])
    })

    this.batteryStringForm = this.fb.group({
      batteryStringFormInput: [],
      batteryString: this.fb.array([])
    });

    this.batteryBatteryForm = this.fb.group({
      batteryBatteryFormInput: [],
      batteryBatteries: this.fb.array([])
    });

    if (this.region === 'Boston Region') {
      this.showPSNumberInput = true;
      this.showPSNumberSelect = false;
    } else if (this.region === 'Freedom Region') {
      this.showPSNumberInput = false;
      this.showPSNumberSelect = true;
      this.PSNOptions = this.PSNFreedomOptions;
    } else if (this.region === 'Keystone Region') {
      if (this.hierarchyPath.includes('Keystone East')) {
        this.PSNOptions = this.PSKeyStoneEastOptions;
      } else if (this.hierarchyPath.includes('Keystone West')) {
        this.PSNOptions = this.PSKeyStoneWestOptions;
      }
    } else if (this.region === 'Beltway Region') {
      this.showPSNumberInput = false;
      this.showPSNumberSelect = true;
      this.PSNOptions = this.PSNOptionsOther;
    } else {
      this.showPSNumberInput = true;
      this.showPSNumberSelect = false;
    }
    this.showForms = true;
  }

  get nodesForms() {
    return this.nodesForm.get('node') as FormArray;
  }

  get batteryStringForms() {
    return this.batteryStringForm.get('batteryString') as FormArray;
  }

  get batteryBatteryForms() {
    return this.batteryBatteryForm.get('batteryBatteries') as FormArray;
  }

  onChangeFeedMultipleNodes(event: any) {
    this.nodeValues = new Array<string>(33);
    this.node2 = '';
    this.node3 = '';
    this.node4 = '';
    this.node5 = '';
    this.onChangeSysLocation();
    if (event !== '' && event !== null && event !== undefined) {
      this.split = event.split(' - ');
      if (this.split[0] !== 'No') {
        const split: string[] = this.split[1].split(' ');
        let numOfNodes = (Number(split[0])) - 1;
        if (numOfNodes > this.prevNodes) {
          for (let i = this.prevNodes; i < numOfNodes; i++) this.addNodes();
        } else if (numOfNodes < this.prevNodes) {
          for (let i = this.prevNodes; i > numOfNodes; i--) this.removeNode(i);
        }
        this.prevNodes = numOfNodes;
      } else {
        this.clearFormArray(this.nodesForms);
        this.nodesForms.controls.splice(0);
        this.prevNodes = 0;
      }
    } else {
      this.clearFormArray(this.nodesForms);
      this.nodesForms.controls.splice(0);
      this.prevNodes = 0;
    }
  }

  formatDateType(dateString) {
    const date = new Date(dateString)
    if (isNaN(date.getTime())) {
      return 'Invalid'
    }
    const day = String(date.getDate()).padStart(2,'0')
    const month = String(date.getMonth() + 1).padStart(2,'0')
    const year = String(date.getFullYear())
    return `${day}-${month}-${year}`
  }

  onScannedData(k) {
    if(this.information.indexOf('C&D') !== -1){
      if(this.information.indexOf('_C&D_') !== -1){
        let scannerDataSplit = this.information.split('_');
        //['A027921', '\r', 'C&D_BBG-220RT', '\r', '2023-12-01']
        this.scanSerialNum = scannerDataSplit[0];
        this.scanBatteryModel = scannerDataSplit[1]+'_'+scannerDataSplit[2];
        let scanSplit = this.formatDateType(scannerDataSplit[3]);
        let scanyearsplit = scanSplit.split('-');
        let scanYear = scanyearsplit[2];
        this.scanManufactureDate = scanyearsplit[1]+scanYear[2]+scanYear[3] //monthyear MMYY
      }else if(this.information.indexOf(' C&D ') !== -1){
        let scannerDataSplit = this.information.split(' ');
        this.scanSerialNum = scannerDataSplit[0];
        this.scanBatteryModel = scannerDataSplit[1]+' '+scannerDataSplit[2];
        let scanSplit = this.formatDateType(scannerDataSplit[3]);
        let scanyearsplit = scanSplit.split('-');
        let scanYear = scanyearsplit[2];
        this.scanManufactureDate = scanyearsplit[1]+scanYear[2]+scanYear[3] //monthyear MMYY
      }else{
         //C&D
        let scannerDataSplit = this.information.split(/(\s+)/);
        console.log(scannerDataSplit)
        //['A027921', '\r', 'C&D_BBG-220RT', '\r', '2023-12-01']
        this.scanSerialNum = scannerDataSplit[0];
        this.scanBatteryModel = scannerDataSplit[2];
        let scanSplit = this.formatDateType(scannerDataSplit[4]);
        let scanyearsplit = scanSplit.split('-');
        let scanYear = scanyearsplit[2];
        this.scanManufactureDate = scanyearsplit[1]+scanYear[2]+scanYear[3] //monthyear MMYY
      }
    }
    else if(this.information.indexOf('ALPHA 3.5 HP') !== -1){
      let scannerDataSplit = this.information.split(/\r?\n/);
      this.scanSerialNum = scannerDataSplit[0];
      this.scanBatteryModel = scannerDataSplit[1];
      let scanSplit = this.formatDateType(scannerDataSplit[2]);
      let scanyearsplit = scanSplit.split('-');
      let scanYear = scanyearsplit[2];
      this.scanManufactureDate = scanyearsplit[1]+scanYear[2]+scanYear[3] //monthyear MMYY
    }
    else if(this.information.indexOf('ALPHA 4.0 HP') !== -1){
      let scannerDataSplit = this.information.split(/(\s+)/);
      console.log(scannerDataSplit)
      // if ['MJ2973549440', '\r\n', 'ALPHA', ' ', '4.0', ' ', 'HP', '\r\n', '03-13-2023']
      // else ['2415330013', ' ', 'MFG', ' ', 'Date;', ' ', '06/01/24', ' ', '00:05', ' ', 'ALPHA', ' ', '4.0', ' ', 'HP']
      if(scannerDataSplit.indexOf('MFG') !== -1){
        //new scenario
        this.scanSerialNum = scannerDataSplit[0];
        this.scanBatteryModel = scannerDataSplit[10]+' '+scannerDataSplit[12]+' '+scannerDataSplit[14];
        let scanSplit = scannerDataSplit[6];
        let scanyearsplit = scanSplit.split('/');//06/01/24
        console.log(scanyearsplit)
        let scanYear = scanyearsplit[2];
        console.log(scanYear)
        this.scanManufactureDate = scanyearsplit[0]+scanYear //monthyear MMYY
      }else{
        //old scenario
        this.scanSerialNum = scannerDataSplit[0];
        this.scanBatteryModel = scannerDataSplit[2]+' '+scannerDataSplit[4]+' '+scannerDataSplit[6];
        let scanSplit = this.formatDateType(scannerDataSplit[8]);
        let scanyearsplit = scanSplit.split('-');
        let scanYear = scanyearsplit[2];
        this.scanManufactureDate = scanyearsplit[1]+scanYear[2]+scanYear[3] //monthyear MMYY
      }
    }
    this.zoomFlag[k] = false;
    this.scanCurrentDate = new Date();

    //check the battery type is exists in battery type or not
    if (!this.batteryManufactureres.includes(this.scanBatteryModel)) {
      this.batteryManufactureres.push(this.scanBatteryModel)
    }
    let event = this.batteryInfoForm.value.numberofBatteries;
    //for (let i = 0; i < (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).length; i++) {

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryManufacturer').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryManufacturer').value);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryManufacturer').
      // patchValue(this.scanBatteryModel[k]);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batterySerial').
      // patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batterySerial').value);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batterySerial').
      // patchValue(this.scanSerialNum[k]);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryCode').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryCode').value);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryCode').
      // patchValue(this.scanManufactureDate[k]);


      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryInstallDate').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryInstallDate').value);

      (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('batteryManufacturer').
        patchValue(this.scanBatteryModel);

       (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('batterySerial').
         patchValue(this.scanSerialNum);

      (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('batteryCode').
        patchValue(this.scanManufactureDate);

      (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[k].get('batteryInstallDate').
        patchValue(this.scanCurrentDate);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryVoltageNoLoad').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryVoltageNoLoad').value);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryVoltageUnderLoad').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryVoltageUnderLoad').value);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryConductance').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryConductance').value);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryConductanceCorrected').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('batteryConductanceCorrected').value);

      // (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('totalVoltage').
      //   patchValue((<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[0].get('totalVoltage').value);

    //}
  }

  scanSuccessHandler($event: any,index) {
    this.information = $event;
    this.scannerEnabled[index] = !this.scannerEnabled;
    this.onScannedData(index)
  }

  enableScanner(index) {
    if(this.scannerEnabled[index]){
      this.zoomFlag[index] = false;
      this.scannerEnabled[index] = false;
      this.scannerEnabled[index] = !this.scannerEnabled;
    }else{
      this.zoomFlag[index] = true;
      this.scannerEnabled[index] = true;
      this.scannerEnabled[index] = this.scannerEnabled;
    }
  }

  onChangeNumberOfBatteries() {
    this.changePSAlertProfile();
    this.addbatteryfusedValidation();
    let event = this.batteryInfoForm.value.numberofBatteries;
    if (event !== '' && event !== null && event !== undefined) {
      const split: string[] = event.split(' ');
        if(event == this.lionBat){
          this.min = 0;
          this.max = 1;
          this.parallelBatt = false;
          this.noOfBatteriesFused = Array(Number(1)).fill(0).map((x, i) => i + 1);
          //if (Number(split[0]) !== 0) {
            let numberOfStrings = 1;
            this.noOfBatteries = 1;
            let batteries = 1;
            let b: Array<number[]> = new Array(numberOfStrings - 1);
            for (let z = 0; z <= numberOfStrings - 1; z++) {
              let a: number[] = new Array(batteries - 1);
              for (let k = 0; k <= batteries - 1; k++) {
                if (k >= this.min && k <= this.max) {
                  a[k] = k;
                }
                else {
                  a[k] = 50;
                }
              }
              b[z] = a;
              this.changeMinMax();
            }
            this.batteryGroup = b;
            if (this.prvString !== null && this.prvString !== undefined) {
              if (numberOfStrings !== this.prvString && numberOfStrings > this.prvString) {
                for (let i = this.prvString; i < numberOfStrings; i++) {
                  this.addBatteries();
                  this.clearValidationOnChange();
                }
              } else if (numberOfStrings !== this.prvString && numberOfStrings < this.prvString) {
                for (let i = this.prvString; i > numberOfStrings; i--) {
                  this.removeString(i);
                }
              }
            }
            if (this.prvBattery !== null && this.prvBattery !== undefined && this.prvString !== null && this.prvString !== undefined) {
              let newArray: any = [];
              let preArray: any = [];
              let battArray: any = [];
              let temp = 0;
              let temp1 = 16;
              for (let i = 0; i < this.prvString; i++) {
                for (let j = 0; j < this.prvBattery; j++)
                  preArray.push(i + '' + j)
              }
              for (let i = 0; i < numberOfStrings; i++) {
                for (let j = 0; j < this.noOfBatteries; j++)
                  newArray.push(i + '' + j)
              }
              for (let i = 0; i < 6; i++) {
                for (let j = 0; j < 4; j++) {
                  if (newArray.includes(i + '' + j) && preArray.includes(i + '' + j)) battArray.push(i + '' + j);
                  else if (newArray.includes(i + '' + j) && !(preArray.includes(i + '' + j))) battArray.push('55');
                  else if (!(newArray.includes(i + '' + j)) && preArray.includes(i + '' + j)) battArray.push('66');
                  else battArray.push('x');
                }
              }
              for (let i = battArray.length - 1; i >= 0; i--) {
                if (battArray[i] == 66) {
                  this.removeBattery(temp1);
                }
                temp1--;
              }
              for (let i = 0; i <= battArray.length - 1; i++) {
                if (battArray[i] !== '66' && battArray[i] !== 'x') {
                  if (battArray[i] == 55) {
                    this.addBatteryBatteries(temp);
                  }
                  temp++;
                }
              }
            }
            this.prvString = numberOfStrings;
            this.prvBattery = this.noOfBatteries;
            this.markAsTouched(this.batteryStringForm);
            this.markAsTouched(this.batteryBatteryForm);
        // }
        }
        if (split[0] == this.parallel) {
        this.parallelBatt = true;
        this.parallelBatteries = event;
        var numberofparallelBatteries = Number(split[1]);
        this.min = 0;
        this.max = Number(split[1]) - 1;
        this.noOfBatteries = numberofparallelBatteries;
        let parallelBatteriesArray: Array<number[]> = new Array(numberofparallelBatteries - 1);
        let numberOfStrings = 1;
        this.noOfBatteriesFused = Array(Number(split[1])).fill(0).map((x, i) => i + 1);
        for (let initialString = 0; initialString < 1; initialString++) {
          let arrayToHoldMultipleBatteriesInSameString: number[] = new Array(numberofparallelBatteries - 1);
          for (let k = 0; k <= numberofparallelBatteries - 1; k++) {
            if (k >= this.min && k <= this.max) {
              arrayToHoldMultipleBatteriesInSameString[k] = k;
            }
          }
          parallelBatteriesArray[initialString] = arrayToHoldMultipleBatteriesInSameString;
          this.changeMinMax();
          this.batteryGroup = parallelBatteriesArray;
        }

        //Logic Existing to be re-used
        if (this.prvString !== null && this.prvString !== undefined) {
          if (numberOfStrings !== this.prvString && numberOfStrings > this.prvString) {
            for (let i = this.prvString; i < numberOfStrings; i++) {
              this.addBatteries();
              this.clearValidationOnChange();
            }
          } else if (numberOfStrings !== this.prvString && numberOfStrings < this.prvString) {
            for (let i = this.prvString; i > numberOfStrings; i--) {
              this.removeString(i);
            }
          }
        }
        if (this.prvBattery !== null && this.prvBattery !== undefined && this.prvString !== null && this.prvString !== undefined) {
          let newArray: any = [];
          let preArray: any = [];
          let battArray: any = [];
          let temp = 0;
          let temp1 = 16;
          for (let i = 0; i < this.prvString; i++) {
            for (let j = 0; j < this.prvBattery; j++)
              preArray.push(i + '' + j)
          }
          for (let i = 0; i < numberOfStrings; i++) {
            for (let j = 0; j < this.noOfBatteries; j++)
              newArray.push(i + '' + j)
          }
          for (let i = 0; i < 1; i++) {
            for (let j = 0; j < 6; j++) {
              if (newArray.includes(i + '' + j) && preArray.includes(i + '' + j)) battArray.push(i + '' + j);
              else if (newArray.includes(i + '' + j) && !(preArray.includes(i + '' + j))) battArray.push('55');
              else if (!(newArray.includes(i + '' + j)) && preArray.includes(i + '' + j)) battArray.push('66');
              else battArray.push('x');
            }
          }
          for (let i = battArray.length - 1; i >= 0; i--) {
            if (battArray[i] == 66) {
              this.removeBattery(temp1);
            }
            temp1--;
          }
          for (let i = 0; i <= battArray.length - 1; i++) {
            if (battArray[i] !== '66' && battArray[i] !== 'x') {
              if (battArray[i] == 55) {
                this.addBatteryBatteries(temp);
              }
              temp++;
            }
          }
        }
        this.prvString = numberOfStrings;
        this.prvBattery = this.noOfBatteries;
        this.markAsTouched(this.batteryStringForm);
        this.markAsTouched(this.batteryBatteryForm);
      } else {
        this.min = 0;
        this.max = Number(split[3]) - 1;
        this.parallelBatt = false;
        this.noOfBatteriesFused = Array(Number(split[3])).fill(0).map((x, i) => i + 1);
        if (Number(split[0]) !== 0) {
          let numberOfStrings = Number(split[0]);
          this.noOfBatteries = Number(split[3]);
          let batteries = Number(split[0]) * Number(split[3]);
          let b: Array<number[]> = new Array(numberOfStrings - 1);
          for (let z = 0; z <= numberOfStrings - 1; z++) {
            let a: number[] = new Array(batteries - 1);
            for (let k = 0; k <= batteries - 1; k++) {
              if (k >= this.min && k <= this.max) {
                a[k] = k;
              }
              else {
                a[k] = 50;
              }
            }
            b[z] = a;
            this.changeMinMax();
          }
          this.batteryGroup = b;
          if (this.prvString !== null && this.prvString !== undefined) {
            if (numberOfStrings !== this.prvString && numberOfStrings > this.prvString) {
              for (let i = this.prvString; i < numberOfStrings; i++) {
                this.addBatteries();
                this.clearValidationOnChange();
              }
            } else if (numberOfStrings !== this.prvString && numberOfStrings < this.prvString) {
              for (let i = this.prvString; i > numberOfStrings; i--) {
                this.removeString(i);
              }
            }
          }
          if (this.prvBattery !== null && this.prvBattery !== undefined && this.prvString !== null && this.prvString !== undefined) {
            let newArray: any = [];
            let preArray: any = [];
            let battArray: any = [];
            let temp = 0;
            let temp1 = 16;
            for (let i = 0; i < this.prvString; i++) {
              for (let j = 0; j < this.prvBattery; j++)
                preArray.push(i + '' + j)
            }
            for (let i = 0; i < numberOfStrings; i++) {
              for (let j = 0; j < this.noOfBatteries; j++)
                newArray.push(i + '' + j)
            }
            for (let i = 0; i < 6; i++) {
              for (let j = 0; j < 4; j++) {
                if (newArray.includes(i + '' + j) && preArray.includes(i + '' + j)) battArray.push(i + '' + j);
                else if (newArray.includes(i + '' + j) && !(preArray.includes(i + '' + j))) battArray.push('55');
                else if (!(newArray.includes(i + '' + j)) && preArray.includes(i + '' + j)) battArray.push('66');
                else battArray.push('x');
              }
            }
            for (let i = battArray.length - 1; i >= 0; i--) {
              if (battArray[i] == 66) {
                this.removeBattery(temp1);
              }
              temp1--;
            }
            for (let i = 0; i <= battArray.length - 1; i++) {
              if (battArray[i] !== '66' && battArray[i] !== 'x') {
                if (battArray[i] == 55) {
                  this.addBatteryBatteries(temp);
                }
                temp++;
              }
            }
          }
          this.prvString = numberOfStrings;
          this.prvBattery = this.noOfBatteries;
          this.markAsTouched(this.batteryStringForm);
          this.markAsTouched(this.batteryBatteryForm);
        } else {
          this.clearFormArray(this.batteryStringForms);
          this.clearFormArray(this.batteryBatteryForms);
          this.batteryStringForms.controls.splice(0);
          this.batteryBatteryForms.controls.splice(0);
          this.prvString = 0;
          this.prvBattery = 0;
        }
      }
    }
    else {
      this.clearFormArray(this.batteryStringForms);
      this.clearFormArray(this.batteryBatteryForms);
      this.prvString = 0;
      this.prvBattery = 0;
      this.batteryStringForms.controls.splice(0);
      this.batteryBatteryForms.controls.splice(0);
    }
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
  }

  onChangeBatteriesReplaced() {
    let event = this.batteryInfoForm.value.batteriesReplaced;

    for (let i = 0; i < (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).length; i++) {
      const batteryManufacturer = (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryManufacturer');
      const batterySerial = (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batterySerial');
      const batteryCode = (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryCode');
      const batteryInstallDate = (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryInstallDate');
      const batteryVoltageNoLoad = (<FormArray>this.batteryBatteryForm.controls['batteryBatteries']).controls[i].get('batteryVoltageNoLoad');

      if (event !== '' && event !== null && event !== undefined && event.toLowerCase() !== 'no') {
        batteryManufacturer.setValidators([Validators.required]);
        batterySerial.setValidators([Validators.required]);
        batteryCode.setValidators([Validators.required, BatteryDateCodeValidation.ValidateBatteryDateCode()]);
        batteryInstallDate.setValidators([Validators.required]);
        batteryVoltageNoLoad.setValidators([Validators.required]);

        batteryManufacturer.updateValueAndValidity();
        batterySerial.updateValueAndValidity();
        batteryCode.updateValueAndValidity();
        batteryInstallDate.updateValueAndValidity();
        batteryVoltageNoLoad.updateValueAndValidity();

        this.markAsTouched(this.batteryBatteryForm);
        this.asterisk = '*';
      } else {
        batteryManufacturer.setValidators(null);
        batterySerial.setValidators(null);
        batteryCode.setValidators([BatteryDateCodeValidation.ValidateBatteryDateCode()]);
        batteryInstallDate.setValidators(null);
        batteryVoltageNoLoad.setValidators(null);

        batteryManufacturer.updateValueAndValidity();
        batterySerial.updateValueAndValidity();
        batteryCode.updateValueAndValidity();
        batteryInstallDate.updateValueAndValidity();
        batteryVoltageNoLoad.updateValueAndValidity();
        this.asterisk = '';
      }
    }
  }
  clearValidationOnChange(){
  //   for (let i = 0; i < (<FormArray>this.batteryStringForms).length; i++) {
  //   if(i == 0){
  //   }else if (i == 1) {
  //     const batteryManufacturer = <FormArray>this.batteryStringForms.controls[i].get('batteryManagerModel');
  //     batteryManufacturer.clearValidators();
  //     batteryManufacturer.updateValueAndValidity();
  //   }else if (i == 2) {
  //     const batteryManufacturer1 = <FormArray>this.batteryStringForms.controls[i].get('batteryManagerModel');
  //     batteryManufacturer1.clearValidators();
  //     batteryManufacturer1.updateValueAndValidity();
  //   }else if (i == 3) {
  //     const batteryManufacturer2= <FormArray>this.batteryStringForms.controls[i].get('batteryManagerModel');
  //     batteryManufacturer2.clearValidators();
  //     batteryManufacturer2.updateValueAndValidity();
  //   }else if (i == 4) {
  //     const batteryManufacturer3 = <FormArray>this.batteryStringForms.controls[i].get('batteryManagerModel');
  //     batteryManufacturer3.clearValidators();
  //     batteryManufacturer3.updateValueAndValidity();
  //   }else if (i == 5) {
  //     const batteryManufacturer4 = <FormArray>this.batteryStringForms.controls[i].get('batteryManagerModel');
  //     batteryManufacturer4.clearValidators();
  //     batteryManufacturer4.updateValueAndValidity();
  // }
  // }
}

  onChangevisitType() {
    let event = this.lastVisitInfoForm.value.typeOfVisit;
    if(event == '' || event == undefined || event == null){
      setTimeout(() => {
        this.lastVisitInfoForm.controls["typeOfVisit"].setValidators(Validators.required);
        this.lastVisitInfoForm.controls["typeOfVisit"].updateValueAndValidity();
      });
    }
    if (event === 'Annual Inspection' || event === 'Maintenance' || event === 'Repair') {
      this.lastVisitInfoForm.controls["inspectionDate"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["inspectionDate"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["typeOfVisit"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["typeOfVisit"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["xocVerified"].setValidators(Validators.required);
      if(!this.permissionValue){
        this.lastVisitInfoForm.controls["mobileno"].updateValueAndValidity();
        this.lastVisitInfoForm.controls["mobileno"].setValidators(Validators.required);
      }
      this.lastVisitInfoForm.controls["xocVerified"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["cleanDust"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["cleanDust"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["tightenAll"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["tightenAll"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["inspectWire"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["inspectWire"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["inspectBattery"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["inspectBattery"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["meterPan"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["meterPan"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["powerCo"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["powerCo"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryHeaterType"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["batteryHeaterType"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryHeaterQuantity"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["batteryHeaterQuantity"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["encloseSnow"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["encloseSnow"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["internalBreaker"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["internalBreaker"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["serviceEntrance"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["serviceEntrance"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["receptacleType"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["receptacleType"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["checkSeizure"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkSeizure"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["psIDLegibile"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["psIDLegibile"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["checkLamps"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkLamps"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["checkCircuitBreaker"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkCircuitBreaker"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["visualInspection"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["visualInspection"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["cabinetLocked"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["cabinetLocked"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["securityBar"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["securityBar"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["checkGround"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkGround"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["tamperInstalled"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["tamperInstalled"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["checkLaps"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkLaps"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["cabinetVendor"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["cabinetVendor"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["cabinetBattery"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["cabinetBattery"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["checkOperating"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["checkOperating"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["followUp"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["followUp"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["inputSurge"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["inputSurge"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["outputSurge"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["outputSurge"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["coaxTvss"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["coaxTvss"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["acIndicator"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["acIndicator"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["lri"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["lri"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["followUpReasons"].setValidators(Validators.required);
      // this.lastVisitInfoForm.controls["followUpReasons"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["visitsStatus"].setValidators(Validators.required);
      this.lastVisitInfoForm.controls["visitsStatus"].updateValueAndValidity();
      this.addbatteryfusedValidation();
      this.asterisk = '*';
    } else {
      Object.keys(this.lastVisitInfoForm.controls).forEach((key: string) => {
        //mobile no mandatory for all the fields
        if(key == 'mobileno' && !this.permissionValue){
          this.lastVisitInfoForm.controls["mobileno"].updateValueAndValidity();
          this.lastVisitInfoForm.controls["mobileno"].setValidators(Validators.required);
        }else{
          const abstractControl = this.lastVisitInfoForm.get(key);
          abstractControl.clearValidators();
          abstractControl.updateValueAndValidity();
        }
      })
      this.asterisk = '';

    }
  }


  addbatteryfusedValidation() {
    let batevent = this.batteryInfoForm.value.numberofBatteries;
    if (this.batteryInfoForm.value.numberofBatteries != undefined) {
      const splits: string[] = batevent.split(' ');
      if (splits[0] == this.parallel) {
        this.noOfBatteries = Number(splits[1]);
      } else {
        this.noOfBatteries = Number(splits[3]);
      }
    }
    let event = this.lastVisitInfoForm.value.typeOfVisit;
    if (event == 'Annual Inspection' || event == 'Maintenance' || event == 'Repair') {
      this.lastVisitInfoForm.controls["batteryStringFused1"].clearValidators();
      this.lastVisitInfoForm.controls["batteryStringFused1"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryStringFused2"].clearValidators();
      this.lastVisitInfoForm.controls["batteryStringFused2"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryStringFused3"].clearValidators();
      this.lastVisitInfoForm.controls["batteryStringFused3"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryStringFused4"].clearValidators();
      this.lastVisitInfoForm.controls["batteryStringFused4"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryStringFused5"].clearValidators();
      this.lastVisitInfoForm.controls["batteryStringFused5"].updateValueAndValidity();
      this.lastVisitInfoForm.controls["batteryStringFused6"].clearValidators();
      this.lastVisitInfoForm.controls["batteryStringFused6"].updateValueAndValidity();
      // for (let i = 0; i < this.noOfBatteries; i++) {
      //   if (i == 0) {
      //     this.lastVisitInfoForm.controls["batteryStringFused1"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused1"].updateValueAndValidity();
      //   } else if (i == 1) {
      //     this.lastVisitInfoForm.controls["batteryStringFused2"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused2"].updateValueAndValidity();
      //   } else if (i == 2) {
      //     this.lastVisitInfoForm.controls["batteryStringFused3"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused3"].updateValueAndValidity();
      //   } else if (i == 3) {
      //     this.lastVisitInfoForm.controls["batteryStringFused4"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused4"].updateValueAndValidity();
      //   }else if (i == 4) {
      //     this.lastVisitInfoForm.controls["batteryStringFused5"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused5"].updateValueAndValidity();
      //   } else if (i == 5) {
      //     this.lastVisitInfoForm.controls["batteryStringFused6"].setValidators(Validators.required);
      //     this.lastVisitInfoForm.controls["batteryStringFused6"].updateValueAndValidity();
      //   }
      // }
    } else {
      // this.lastVisitInfoForm.controls["batteryStringFused1"].clearValidators();
      // this.lastVisitInfoForm.controls["batteryStringFused1"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["batteryStringFused2"].clearValidators();
      // this.lastVisitInfoForm.controls["batteryStringFused2"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["batteryStringFused3"].clearValidators();
      // this.lastVisitInfoForm.controls["batteryStringFused3"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["batteryStringFused4"].clearValidators();
      // this.lastVisitInfoForm.controls["batteryStringFused4"].updateValueAndValidity();

      // this.lastVisitInfoForm.controls["batteryStringFused5"].clearValidators();
      // this.lastVisitInfoForm.controls["batteryStringFused5"].updateValueAndValidity();
      // this.lastVisitInfoForm.controls["batteryStringFused6"].clearValidators();
      // this.lastVisitInfoForm.controls["batteryStringFused6"].updateValueAndValidity();
    }

  }


  addNodes() {
    const node = this.fb.group({
      node: ['', Validators.required]
    })
    this.nodesForms.push(node);
    this.markAsTouched(this.nodesForm);
    this.manageNameControl(this.nodesForms.length - 1);
  }

  manageNameControl(index) {
    this.nodesForms.at(index).get('node')
      .valueChanges
      //.pipe(debounceTime(600))
      .pipe(debounceTime(100),
      tap(() => {
         this.isLoadingdata = true;
      }),
      )
      .subscribe(searchWord => {
        if (this.validateFN){
          if(this.validationFlag){
            this.nodesForms.at(index).get('node').setErrors({ required: true });
            this.ref.detectChanges();
          }
          this.filterNodeOptions[index] = this.nodeService.resourceNodeServiceResourceAdvancedSearchGET(searchWord).pipe(shareReplay({refCount:true,bufferSize:1}),map(res => res));
        }
        else{
          this.nodesForms.at(index).get('node').setErrors({ required: true });
          this.ref.detectChanges();
          this.filterNodeOptions[index] = this.nodeService.resourceNodeServiceResourceAdvancedSearchGET(searchWord).pipe(shareReplay({refCount:true,bufferSize:1}),map(res => res.filter((item: JsonAdvancedSearchResult) => item.nodeCommunintyServed === this.communityServed)));
        }
        this.validationFlag = false;
        this.filterNodeOptions[index].subscribe(nodes => {
          if (nodes.length > 0 && nodes.find(x => x.node.toUpperCase() == searchWord.toUpperCase())) {
            this.nodesForms.at(index).get('node').setErrors(null);
            this.updateForm(searchWord, index);
            this.isLoadingdata = false;
          } else {
            this.nodesForms.at(index).get('node').markAsDirty();
            this.nodesForms.at(index).get('node').markAsTouched();
            this.nodesForms.at(index).get('node').setErrors({ nodeError: true });
            this.isLoadingdata = false;
          }
        });
      });
  }

  addBatteries() {
    const batteryString = this.fb.group({
      //batteryManagerModel: ['', Validators.required],
      //batterySeparator: []
    });
    this.batteryStringForms.push(batteryString);
  }

  addBatteryBatteries(index) {
    let batteriesReplaced: string = this.batteryInfoForm.value.batteriesReplaced;
    let batteryBattery;
    if (batteriesReplaced == undefined || batteriesReplaced == '' || batteriesReplaced.toLowerCase() == 'no') {
      batteryBattery = this.fb.group({
        batteryManufacturer: [''],
        batterySerial:[''],
        batteryCode: ['', [BatteryDateCodeValidation.ValidateBatteryDateCode()]],
        batteryInstallDate: [''],
        batteryVoltageNoLoad: [''],
        batteryVoltageUnderLoad: [''],
        batteryConductance: [''],
        batteryConductanceCorrected: [''],
        totalVoltage: ['']
      });
      this.asterisk = '';
    } else {
      batteryBattery = this.fb.group({
        batteryManufacturer: ['', Validators.required],
        batterySerial: ['', Validators.required],
        batteryCode: ['', [Validators.required, BatteryDateCodeValidation.ValidateBatteryDateCode()]],
        batteryInstallDate: ['', Validators.required],
        batteryVoltageNoLoad: ['', Validators.required],
        batteryVoltageUnderLoad: [''],
        batteryConductance: [''],
        batteryConductanceCorrected: [''],
        totalVoltage: ['']
      });
      this.asterisk = '*';
    }
    this.batteryBatteryForms.insert(index, batteryBattery);
    this.ref.detectChanges();
  }

  removeString(index) {
    const control = <FormArray>this.batteryStringForms;
    control.removeAt(index - 1);
  }

  removeBattery(index) {
    const control = <FormArray>this.batteryBatteryForms;
    control.removeAt(index - 1);
  }

  removeNode(index) {
    const control = <FormArray>this.nodesForms;
    control.removeAt(index - 1);
    this.filterNodeOptions.splice(index - 1, 1);
  }

  selectNext(index) {
    index.selectedIndex += 1;
  }

  changeMinMax() {
    const temp = this.max - this.min;
    this.max = this.max + temp + 1;
    this.min = this.min + temp + 1;
  }

  IsTrue(i, j) {
    if (this.batteryGroup[i][j] === j) {
      return true;
    }
    else {
      return false;
    }
  }

  changePowerSupplyModel(result) {
    if (result.value == null || result.value == '' || result.value == undefined || result.value.toUpperCase() !== 'AM COMMUNICATIONS') {
      this.showPowerSupplyModel = true;
      this.showPowerSupplyType9360 = false;
      if (this.transponderInfoForm.controls['powerSupplyModel'].value === null
        || this.transponderInfoForm.controls['powerSupplyModel'].value === undefined
        || this.transponderInfoForm.controls['powerSupplyModel'].value === '') {
        setTimeout(() => {
          this.transponderInfoForm.controls['powerSupplyModel'].patchValue(undefined);
          this.transponderInfoForm.controls['powerSupplyModel'].setErrors({ validatePowerSupplyModel: true });
          this.transponderInfoForm.controls['powerSupplyModel'].markAsDirty();
          this.transponderInfoForm.controls['powerSupplyModel'].markAsTouched();
          this.transponderInfoForm.controls['powerSupplyModel'].updateValueAndValidity();
          this.transponderInfoForm.controls['powerSupplyType9360'].patchValue('');
          this.transponderInfoForm.controls['powerSupplyType9360'].setErrors(null);
        });
      }
    }
    else {
      this.showPowerSupplyModel = false;
      this.showPowerSupplyType9360 = true;
      if (this.transponderInfoForm.controls['powerSupplyType9360'].value === null
        || this.transponderInfoForm.controls['powerSupplyType9360'].value === undefined
        || this.transponderInfoForm.controls['powerSupplyType9360'].value === '') {
        setTimeout(() => {
          this.transponderInfoForm.controls['powerSupplyType9360'].patchValue('');
          this.transponderInfoForm.controls['powerSupplyType9360'].setErrors({ validatePowerSupply9360: true });
          this.transponderInfoForm.controls['powerSupplyType9360'].markAsDirty();
          this.transponderInfoForm.controls['powerSupplyType9360'].markAsTouched();
          this.transponderInfoForm.controls['powerSupplyType9360'].updateValueAndValidity();
          this.transponderInfoForm.controls['powerSupplyModel'].patchValue('');
          this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null);
        });
      }
    }
  }

  onMacChange(result) {
    if (result !== null && result !== undefined) {
      if (result.length === 17 && this.transponderInfoForm.controls['activeMacAddress'].status === 'VALID') this.pullTransponderButton = true;
      else this.pullTransponderButton = false;
      if (this.originalMac !== result)
        this.transponderInfoForm.controls['prevMacAddress'].patchValue(this.originalMac);
      else this.transponderInfoForm.controls['prevMacAddress'].patchValue('');
    } else this.pullTransponderButton = true;
  }

  onPullTransponder() {
    this.showPowerSupplyType9360 = false;//added for hiding the ps type on edit page load
    let mac: string = this.transponderInfoForm.controls['activeMacAddress'].value;
    if (mac !== null && mac.length === 17) {
      if (mac.substring(0, 2) == 'aa' || mac.substring(0, 2) == 'bb' || mac.substring(0, 2) == 'cc' || mac.substring(0, 2) == 'dd' || mac.substring(0, 2) == 'ee') {
        this.transponderInfoForm.controls['activeMacAddress'].patchValue(mac);
        this.transponderInfoForm.controls['ip'].patchValue('0.0.0.0');
        this.transponderInfoForm.controls['transponderVendor'].patchValue('Unknown');
        this.transponderInfoForm.controls['transponderModel'].patchValue('Unknown');
        this.showPowerSupplyModel = true;
        this.showPowerSupplyType9360 = false;
        if (this.transponderInfoForm.controls['powerSupplyModel'].value === null || this.transponderInfoForm.controls['powerSupplyModel'].value === undefined || this.transponderInfoForm.controls['powerSupplyModel'].value === '') {
          this.transponderInfoForm.controls['powerSupplyModel'].patchValue('Unknown');
          this.transponderInfoForm.controls['powerSupplyModel'].setErrors({ validatePowerSupplyModel: true });
        } else {
          this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null);
        }
      } else {
        this.showProgressBar = true;
        const ip: IP = {};
        ip.macAddress = mac;
        ip.nodeId = this.nodeId;
        if (environment.pullTransponderUseGenome) {
          // this.powerSupplyService.pullTransponderByMacAddress(mac)
          //   .subscribe(result => {
            this.powerSupplyService.pullTransponder(ip)
            .subscribe(result => {
              if (result !== null) {
                if(result.transponderVendor !== null){
                  if(!this.transponderVendors.includes(result.transponderVendor)){
                    this.transponderVendors.push(result.transponderVendor)
                  }
                }else{
                  this.transponderInfoForm.controls['transponderVendor'].patchValue('')
                }
                if(result.transponderModel !== null){
                  if(!this.transponderModels.includes(result.transponderModel)){
                    this.transponderModels.push(result.transponderModel);
                    this.transponderInfoForm.controls['transponderModel'].patchValue(result.transponderModel);
                    this.ref.detectChanges()
                  }else{
                    //if same data is avaliable in dropdown select the genome call value
                    this.transponderInfoForm.controls['transponderModel'].patchValue(result.transponderModel);
                  }
                }else{
                  this.transponderInfoForm.controls['transponderModel'].patchValue('')
                }
                if(result.powerSupplyModel !== null){
                  if(!this.powerSupplyModels.includes(result.powerSupplyModel)){
                    this.powerSupplyModels.push(result.powerSupplyModel);
                    this.transponderInfoForm.controls['powerSupplyModel'].patchValue(result.powerSupplyModel);
                    this.ref.detectChanges()
                  }else{
                    //if same data is avaliable in dropdown select the genome call value
                    this.transponderInfoForm.controls['powerSupplyModel'].patchValue(result.powerSupplyModel);
                  }
                }else{
                  this.transponderInfoForm.controls['powerSupplyModel'].patchValue('');
                }
                if(result.transponderVendor !== null){
                  if (this.transponderVendors.includes(result.transponderVendor)) {
                    this.transponderInfoForm.controls['transponderVendor'].patchValue(result.transponderVendor);
                  } else if (this.transponderVendors.includes(result.transponderVendor.toUpperCase())) {
                    this.transponderInfoForm.controls['transponderVendor'].patchValue(result.transponderVendor.toUpperCase());
                  } else {
                    this.transponderInfoForm.controls['transponderVendor'].patchValue(this.titleCase(result.transponderVendor));
                  }
                }
                if(result.macAddress !== null){
                  this.transponderInfoForm.controls['activeMacAddress'].patchValue(result.macAddress);
                }

                if(result.ipAddress !== null){
                  this.transponderInfoForm.controls['ip'].patchValue(result.ipAddress);
                }else{
                  this.transponderInfoForm.controls['ip'].patchValue('0.0.0.0');
                }
                if(result.transponderModel !== null){
                  this.transponderInfoForm.controls['transponderModel'].patchValue(result.transponderModel.toString());
                }

                this.originalMac = result.macAddress;
                if(result.transponderVendor !== null){
                if (result.transponderVendor.toUpperCase() === 'AM COMMUNICATIONS') {
                  this.showPowerSupplyModel = false;
                  this.showPowerSupplyType9360 = true;
                  if (this.transponderInfoForm.controls['powerSupplyType9360'].value === null || this.transponderInfoForm.controls['powerSupplyType9360'].value === undefined || this.transponderInfoForm.controls['powerSupplyType9360'].value === '') {
                    this.transponderInfoForm.controls['powerSupplyType9360'].patchValue('');
                    this.transponderInfoForm.controls['powerSupplyType9360'].setErrors({ validatePowerSupply9360: true });
                  } else {
                    this.transponderInfoForm.controls['powerSupplyModel'].patchValue('');
                    this.transponderInfoForm.controls['powerSupplyType9360'].setErrors(null);
                    this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null)
                  }
                } else {
                  this.showPowerSupplyModel = true;
                  this.showPowerSupplyType9360 = false;
                  if (this.transponderInfoForm.controls['powerSupplyModel'].value === null || this.transponderInfoForm.controls['powerSupplyModel'].value === undefined || this.transponderInfoForm.controls['powerSupplyModel'].value === '') {
                    this.transponderInfoForm.controls['powerSupplyModel'].patchValue('Unknown');
                  } else {
                    this.transponderInfoForm.controls['powerSupplyType9360'].patchValue('');
                    this.transponderInfoForm.controls['powerSupplyType9360'].setErrors(null);
                    this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null)
                  }
                }


              } else {
                if (this.transponderInfoForm.controls['powerSupplyModel'].value === null || this.transponderInfoForm.controls['powerSupplyModel'].value === undefined || this.transponderInfoForm.controls['powerSupplyModel'].value === '')
                  this.transponderInfoForm.controls['powerSupplyModel'].setErrors({ validatePowerSupplyModel: true });
                else
                  this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null);
              }
            }
              this.showProgressBar = false;
            });
        } else {
          this.powerSupplyService.pullTransponder(ip)
            .subscribe(result => {
              if (result !== null) {
                if (result.transponderVendor.toUpperCase() === 'AM COMMUNICATIONS') {
                  this.transponderInfoForm.controls['activeMacAddress'].patchValue(result.macAddress);
                  this.transponderInfoForm.controls['ip'].patchValue(result.ipAddress);
                  this.transponderInfoForm.controls['transponderVendor'].patchValue(result.transponderVendor.toUpperCase());
                  this.transponderInfoForm.controls['transponderModel'].patchValue(result.transponderModel.toString());
                  this.originalMac = result.macAddress;
                  this.showPowerSupplyModel = false;
                  this.showPowerSupplyType9360 = true;
                  if (this.transponderInfoForm.controls['powerSupplyType9360'].value === null || this.transponderInfoForm.controls['powerSupplyType9360'].value === undefined || this.transponderInfoForm.controls['powerSupplyType9360'].value === '') {
                    this.transponderInfoForm.controls['powerSupplyType9360'].patchValue('');
                    this.transponderInfoForm.controls['powerSupplyType9360'].setErrors({ validatePowerSupply9360: true });
                  } else {
                    this.transponderInfoForm.controls['powerSupplyModel'].patchValue('');
                    this.transponderInfoForm.controls['powerSupplyType9360'].setErrors(null);
                    this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null)
                  }
                } else {
                  this.transponderInfoForm.controls['activeMacAddress'].patchValue(result.macAddress);
                  this.transponderInfoForm.controls['ip'].patchValue(result.ipAddress);
                  this.transponderInfoForm.controls['transponderVendor'].patchValue(result.transponderVendor);
                  this.transponderInfoForm.controls['transponderModel'].patchValue(result.transponderModel);
                  this.originalMac = result.macAddress;
                  this.showPowerSupplyModel = true;
                  this.showPowerSupplyType9360 = false;
                  if (this.transponderInfoForm.controls['powerSupplyModel'].value === null || this.transponderInfoForm.controls['powerSupplyModel'].value === undefined || this.transponderInfoForm.controls['powerSupplyModel'].value === '') {
                    this.transponderInfoForm.controls['powerSupplyModel'].patchValue('Unknown');
                  } else {
                    this.transponderInfoForm.controls['powerSupplyType9360'].patchValue('');
                    this.transponderInfoForm.controls['powerSupplyType9360'].setErrors(null);
                    this.transponderInfoForm.controls['powerSupplyModel'].setErrors(null)
                  }
                }
                // if (result.tranponderInvCmts) {
                //   this.openPopUp(true);
                // }
              }
              this.showProgressBar = false;
            });
        }
      }
    } else this.pullTransponderButton = true;
  }

  openPopUp(tranponderInvCmts: boolean) {
    this.bottomSheet.open(BottomSheetComponent, {
      data: tranponderInvCmts
    });
  }
  openDialog(message: string) {
    this.validationErrorDialog = this.dialog.open(ValidationErrorDialog, {
      data: {
        message: message ? message : ''
      },
      disableClose: true
    })
    this.validationErrorDialog.afterClosed().subscribe(() => { });
  }

  changePSAlertProfile() {
    let acInputVoltage = this.transponderInfoForm.value.acInputVoltage;
    let outputVoltage = this.transponderInfoForm.value.acOutputVoltage;
    let inputCurrent = this.transponderInfoForm.value.currentAmp;
    //let currentAmpOutput = this.transponderInfoForm.value.currentAmpOutput;
    let numberOfBatteries = this.batteryInfoForm.value.numberofBatteries;

    this.powerSupplyAlertProfile = this.commonService.getUnifiedPSAlertProfile(acInputVoltage,
      outputVoltage, inputCurrent,numberOfBatteries, this.division);
  }

  onClickGenerateMac() {
    this.powerSupplyService.generateMacAddress(this.region)
      .subscribe(result => {
        if (result !== null) {
          this.enablephotoStatus = false;
          this.activeMacAddresscopy = result.mac;
          this.transponderInfoForm.controls['activeMacAddress'].patchValue(result.mac);
          this.transponderInfoForm.controls['ip'].patchValue(result.ipAddress);
          this.transponderInfoForm.controls['transponderVendor'].patchValue(result.vendor);
          this.transponderInfoForm.controls['transponderModel'].patchValue(result.model);
          if (result.mac.length === 17) this.pullTransponderButton = true;
        }
      });
  }

  onClickGenerateIP() {
    if (this.transponderInfoForm.value.activeMacAddress !== undefined && this.transponderInfoForm.value.activeMacAddress !== null) {
      const ip: IP = {};
      ip.macAddress = this.transponderInfoForm.value.activeMacAddress;
      ip.nodeId = this.nodeId;
      this.powerSupplyService.generateIpAddress(ip)
        .subscribe(result => {
          if (result.success === true) {
            this.transponderInfoForm.controls['ip'].patchValue(result.message);
          }
        });
    }
  }

  onChangePowerSupplyType() {
    let event = this.transponderInfoForm.value.standByOpts;
    if (event !== null && event !== undefined && event !== '')
      this.selectedPSType = event;
    else this.selectedPSType = 'hint';
  }


  updateFormId(nodeValue: any, index: number) {
    if (nodeValue !== null) {
      this.nodeIdValues[index] = nodeValue.nodeId;
      this.updateForm(nodeValue.node, index);
    }
    else {
      this.nodeIdValues[index] = null;
    }
    switch (index) {
      case 0:
        this.node2_id = this.nodeIdValues[0];
        break;
      case 1:
        this.node3_id = this.nodeIdValues[1];
        break;
      case 2:
        this.node4_id = this.nodeIdValues[2];
        break;
      case 3:
        this.node5_id = this.nodeIdValues[3];
        break;
      case 4:
        this.node6_id = this.nodeIdValues[4];
        break;
      case 5:
        this.node7_id = this.nodeIdValues[5];
        break;
      case 6:
        this.node8_id = this.nodeIdValues[6];
        break;
      case 7:
        this.node9_id = this.nodeIdValues[7];
        break;
      case 8:
        this.node10_id = this.nodeIdValues[8];
        break;
      case 9:
        this.node11_id = this.nodeIdValues[9];
        break;
      case 10:
        this.node12_id = this.nodeIdValues[10];
        break;
      case 11:
        this.node13_id = this.nodeIdValues[11];
        break;
      case 12:
        this.node14_id = this.nodeIdValues[12];
        break;
      case 13:
        this.node15_id = this.nodeIdValues[13];
        break;
      case 14:
        this.node16_id = this.nodeIdValues[14];
        break;
      case 15:
        this.node17_id = this.nodeIdValues[15];
        break;
      case 16:
        this.node18_id = this.nodeIdValues[16];
        break;
      case 17:
        this.node19_id = this.nodeIdValues[17];
        break;
      case 18:
        this.node20_id = this.nodeIdValues[18];
        break;
      case 19:
        this.node21_id = this.nodeIdValues[19];
        break;
      case 20:
        this.node22_id = this.nodeIdValues[20];
        break;
      case 21:
        this.node23_id = this.nodeIdValues[21];
        break;
      case 22:
        this.node24_id = this.nodeIdValues[22];
        break;
      case 23:
        this.node25_id = this.nodeIdValues[23];
        break;
      case 24:
        this.node26_id = this.nodeIdValues[24];
        break;
      case 25:
        this.node27_id = this.nodeIdValues[25];
        break;
      case 26:
        this.node28_id = this.nodeIdValues[26];
        break;
      case 27:
        this.node29_id = this.nodeIdValues[27];
        break;
      case 28:
        this.node30_id = this.nodeIdValues[28];
        break;
      case 29:
        this.node31_id = this.nodeIdValues[29];
        break;
      case 30:
        this.node32_id = this.nodeIdValues[30];
        break;
      default:
        return;
    }
  }


  updateForm(node: string, index: number) {
    if (node !== undefined && node !== '') {
      this.nodeValues[index] = node.toUpperCase();
    }
    else {
      this.nodeValues[index] = null;
    }
    if (this.nodeValues[0] === undefined || this.nodeValues[0] === '' || this.nodeValues[0] === null) {
      this.node2 = '';
    } else this.node2 = this.nodeValues[0];

    if (this.nodeValues[1] === undefined || this.nodeValues[1] === '' || this.nodeValues[1] === null) {
      this.node3 = '';
    } else this.node3 = this.nodeValues[1];

    if (this.nodeValues[2] === undefined || this.nodeValues[2] === '' || this.nodeValues[2] === null) {
      this.node4 = '';
    } else this.node4 = this.nodeValues[2];

    if (this.nodeValues[3] === undefined || this.nodeValues[3] === '' || this.nodeValues[3] === null) {
      this.node5 = '';
    } else this.node5 = this.nodeValues[3];

    if (this.nodeValues[4] === undefined || this.nodeValues[4] === '' || this.nodeValues[4] === null) {
      this.node6 = '';
    } else this.node6 = this.nodeValues[4];

    if (this.nodeValues[5] === undefined || this.nodeValues[5] === '' || this.nodeValues[5] === null) {
      this.node7 = '';
    } else this.node7 = this.nodeValues[5];

    if (this.nodeValues[6] === undefined || this.nodeValues[6] === '' || this.nodeValues[6] === null) {
      this.node8 = '';
    } else this.node8 = this.nodeValues[6];

    if (this.nodeValues[7] === undefined || this.nodeValues[7] === '' || this.nodeValues[7] === null) {
      this.node9 = '';
    } else this.node9 = this.nodeValues[3];

    if (this.nodeValues[8] === undefined || this.nodeValues[8] === '' || this.nodeValues[8] === null) {
      this.node10 = '';
    } else this.node10 = this.nodeValues[8];

    if (this.nodeValues[9] === undefined || this.nodeValues[9] === '' || this.nodeValues[9] === null) {
      this.node11 = '';
    } else this.node11 = this.nodeValues[9];

    if (this.nodeValues[10] === undefined || this.nodeValues[10] === '' || this.nodeValues[10] === null) {
      this.node12 = '';
    } else this.node12 = this.nodeValues[10];

    if (this.nodeValues[11] === undefined || this.nodeValues[11] === '' || this.nodeValues[11] === null) {
      this.node13 = '';
    } else this.node13 = this.nodeValues[11];

    if (this.nodeValues[12] === undefined || this.nodeValues[12] === '' || this.nodeValues[12] === null) {
      this.node14 = '';
    } else this.node14 = this.nodeValues[12];

    if (this.nodeValues[13] === undefined || this.nodeValues[13] === '' || this.nodeValues[13] === null) {
      this.node15 = '';
    } else this.node15 = this.nodeValues[13];

    if (this.nodeValues[14] === undefined || this.nodeValues[14] === '' || this.nodeValues[14] === null) {
      this.node16 = '';
    } else this.node16 = this.nodeValues[14];

    if (this.nodeValues[15] === undefined || this.nodeValues[15] === '' || this.nodeValues[15] === null) {
      this.node17 = '';
    } else this.node17 = this.nodeValues[15];

    if (this.nodeValues[16] === undefined || this.nodeValues[16] === '' || this.nodeValues[16] === null) {
      this.node18 = '';
    } else this.node18 = this.nodeValues[16];

    if (this.nodeValues[17] === undefined || this.nodeValues[17] === '' || this.nodeValues[17] === null) {
      this.node19 = '';
    } else this.node19 = this.nodeValues[17];

    if (this.nodeValues[18] === undefined || this.nodeValues[18] === '' || this.nodeValues[18] === null) {
      this.node20 = '';
    } else this.node20 = this.nodeValues[18];

    if (this.nodeValues[19] === undefined || this.nodeValues[19] === '' || this.nodeValues[19] === null) {
      this.node21 = '';
    } else this.node21 = this.nodeValues[19];

    if (this.nodeValues[20] === undefined || this.nodeValues[20] === '' || this.nodeValues[20] === null) {
      this.node22 = '';
    } else this.node22 = this.nodeValues[20];

    if (this.nodeValues[21] === undefined || this.nodeValues[21] === '' || this.nodeValues[21] === null) {
      this.node23 = '';
    } else this.node23 = this.nodeValues[21];

    if (this.nodeValues[22] === undefined || this.nodeValues[22] === '' || this.nodeValues[22] === null) {
      this.node24 = '';
    } else this.node24 = this.nodeValues[22];

    if (this.nodeValues[23] === undefined || this.nodeValues[23] === '' || this.nodeValues[23] === null) {
      this.node25 = '';
    } else this.node25 = this.nodeValues[23];

    if (this.nodeValues[24] === undefined || this.nodeValues[24] === '' || this.nodeValues[24] === null) {
      this.node26 = '';
    } else this.node26 = this.nodeValues[24];

    if (this.nodeValues[25] === undefined || this.nodeValues[25] === '' || this.nodeValues[25] === null) {
      this.node27 = '';
    } else this.node27 = this.nodeValues[25];

    if (this.nodeValues[26] === undefined || this.nodeValues[26] === '' || this.nodeValues[26] === null) {
      this.node28 = '';
    } else this.node28 = this.nodeValues[26];

    if (this.nodeValues[27] === undefined || this.nodeValues[27] === '' || this.nodeValues[27] === null) {
      this.node29 = '';
    } else this.node29 = this.nodeValues[27];

    if (this.nodeValues[28] === undefined || this.nodeValues[28] === '' || this.nodeValues[28] === null) {
      this.node30 = '';
    } else this.node30 = this.nodeValues[28];

    if (this.nodeValues[29] === undefined || this.nodeValues[29] === '' || this.nodeValues[29] === null) {
      this.node31 = '';
    } else this.node31 = this.nodeValues[29];

    if (this.nodeValues[30] === undefined || this.nodeValues[30] === '' || this.nodeValues[30] === null) {
      this.node32 = '';
    } else this.node32 = this.nodeValues[30];

    this.onChangeSysLocation();
  }

  checkValidProfile(): boolean{
    return this.telemetryThresholdProfileData.includes(this.powerSupplyAlertProfile);
  }

  create() {
    let cat1 = localStorage.getItem('cat1')
    let cat2 = localStorage.getItem('cat2')
    let cat3 = localStorage.getItem('cat3')
    let cat4 = localStorage.getItem('cat4')
    let cat5 = localStorage.getItem('cat5')
    let cat6 = localStorage.getItem('cat6')
    let cat7 = localStorage.getItem('cat7')
    let cat8 = localStorage.getItem('cat8')
    let cat9 = localStorage.getItem('cat9')
    let cat10 = localStorage.getItem('cat10')
    let cat11 = localStorage.getItem('cat11')
    if(cat1 != null || cat2 != null || cat3 != null || cat4 != null || cat5 != null
    || cat6 != null || cat7 != null || cat8 != null || cat9 != null || cat10 != null
    || cat11 != null ){
      this.submitFlag = true;
    }
    this.ref.markForCheck();
    if (!this.checkValidProfile()) {
      this.transponderInfoForm.patchValue({
        acInputVoltage: null,
        acOutputVoltage: null,
        currentAmp: null,
        //currentAmpOutput: null
      });
      let errMessage = "Power Supply Alert Profile is Invalid.";
      this.openDialog(errMessage);
      return;
    } else {

      this.showProgressspinner = true;
      const powerSupply: PowerSupply = {};
      const nodePowersupply: Node = {};
      powerSupply.powerSupplyName = this.powerSupplyName;

      //Location Info
      powerSupply.houseNumber = this.locationInfoForm.value.houseNumberInput;
      powerSupply.powerSupplyAddress = this.locationInfoForm.value.street;
      powerSupply.crossStreet = this.locationInfoForm.value.crossStreet;
      powerSupply.city = this.locationInfoForm.value.city;
      powerSupply.state = this.locationInfoForm.value.state;
      powerSupply.zip = this.locationInfoForm.value.zip;
      powerSupply.feedsMultipleNodes = this.locationInfoForm.value.mutliNodes;
      powerSupply.businessPartnerRestriction = this.locationInfoForm.value.businessPartnerRestriction;
      if (this.nodesForms.at(0) != null) {
        powerSupply.node2 = this.nodesForms.at(0).get('node').value;
        powerSupply.node2_id = this.node2_id;
      }
      if (this.nodesForms.at(1) != null) {
        powerSupply.node3 = this.nodesForms.at(1).get('node').value;
        powerSupply.node3_id = this.node3_id;
      }
      if (this.nodesForms.at(2) != null) {
        powerSupply.node4 = this.nodesForms.at(2).get('node').value;
        powerSupply.node4_id = this.node4_id;
      }
      if (this.nodesForms.at(3) != null) {
        powerSupply.node5 = this.nodesForms.at(3).get('node').value;
        powerSupply.node5_id = this.node5_id;
      }
      if (this.nodesForms.at(4) != null) {
        powerSupply.node6 = this.nodesForms.at(4).get('node').value;
        powerSupply.node6_id = this.node6_id;
      }
      if (this.nodesForms.at(5) != null) {
        powerSupply.node7 = this.nodesForms.at(5).get('node').value;
        powerSupply.node7_id = this.node7_id;
      }
      if (this.nodesForms.at(6) != null) {
        powerSupply.node8 = this.nodesForms.at(6).get('node').value;
        powerSupply.node8_id = this.node8_id;
      }
      if (this.nodesForms.at(7) != null) {
        powerSupply.node9 = this.nodesForms.at(7).get('node').value;
        powerSupply.node9_id = this.node9_id;
      }
      if (this.nodesForms.at(8) != null) {
        powerSupply.node10 = this.nodesForms.at(8).get('node').value;
        powerSupply.node10_id = this.node10_id;
      }
      if (this.nodesForms.at(9) != null) {
        powerSupply.node11 = this.nodesForms.at(9).get('node').value;
        powerSupply.node11_id = this.node11_id;
      }
      if (this.nodesForms.at(10) != null) {
        powerSupply.node12 = this.nodesForms.at(10).get('node').value;
        powerSupply.node12_id = this.node12_id;
      }
      if (this.nodesForms.at(11) != null) {
        powerSupply.node13 = this.nodesForms.at(11).get('node').value;
        powerSupply.node13_id = this.node13_id;
      }
      if (this.nodesForms.at(12) != null) {
        powerSupply.node14 = this.nodesForms.at(12).get('node').value;
        powerSupply.node14_id = this.node14_id;
      }
      if (this.nodesForms.at(13) != null) {
        powerSupply.node15 = this.nodesForms.at(13).get('node').value;
        powerSupply.node15_id = this.node15_id;
      }
      if (this.nodesForms.at(14) != null) {
        powerSupply.node16 = this.nodesForms.at(14).get('node').value;
        powerSupply.node16_id = this.node16_id;
      }
      if (this.nodesForms.at(15) != null) {
        powerSupply.node17 = this.nodesForms.at(15).get('node').value;
        powerSupply.node17_id = this.node17_id;
      }
      if (this.nodesForms.at(16) != null) {
        powerSupply.node18 = this.nodesForms.at(16).get('node').value;
        powerSupply.node18_id = this.node18_id;
      }
      if (this.nodesForms.at(17) != null) {
        powerSupply.node19 = this.nodesForms.at(17).get('node').value;
        powerSupply.node19_id = this.node19_id;
      }
      if (this.nodesForms.at(18) != null) {
        powerSupply.node20 = this.nodesForms.at(18).get('node').value;
        powerSupply.node20_id = this.node20_id;
      }
      if (this.nodesForms.at(19) != null) {
        powerSupply.node21 = this.nodesForms.at(19).get('node').value;
        powerSupply.node21_id = this.node21_id;
      }
      if (this.nodesForms.at(20) != null) {
        powerSupply.node22 = this.nodesForms.at(20).get('node').value;
        powerSupply.node22_id = this.node22_id;
      }
      if (this.nodesForms.at(21) != null) {
        powerSupply.node23 = this.nodesForms.at(21).get('node').value;
        powerSupply.node23_id = this.node23_id;
      }
      if (this.nodesForms.at(22) != null) {
        powerSupply.node24 = this.nodesForms.at(22).get('node').value;
        powerSupply.node24_id = this.node24_id;
      }
      if (this.nodesForms.at(23) != null) {
        powerSupply.node25 = this.nodesForms.at(23).get('node').value;
        powerSupply.node25_id = this.node25_id;
      }
      if (this.nodesForms.at(24) != null) {
        powerSupply.node26 = this.nodesForms.at(24).get('node').value;
        powerSupply.node26_id = this.node26_id;
      }
      if (this.nodesForms.at(25) != null) {
        powerSupply.node27 = this.nodesForms.at(25).get('node').value;
        powerSupply.node27_id = this.node27_id;
      }
      if (this.nodesForms.at(26) != null) {
        powerSupply.node28 = this.nodesForms.at(26).get('node').value;
        powerSupply.node28_id = this.node28_id;
      }
      if (this.nodesForms.at(27) != null) {
        powerSupply.node29 = this.nodesForms.at(27).get('node').value;
        powerSupply.node29_id = this.node29_id;
      }
      if (this.nodesForms.at(28) != null) {
        powerSupply.node30 = this.nodesForms.at(28).get('node').value;
        powerSupply.node30_id = this.node30_id;
      }
      if (this.nodesForms.at(29) != null) {
        powerSupply.node31 = this.nodesForms.at(29).get('node').value;
        powerSupply.node31_id = this.node31_id;
      }
      if (this.nodesForms.at(30) != null) {
        powerSupply.node32 = this.nodesForms.at(30).get('node').value;
        powerSupply.node32_id = this.node32_id;
      }
      powerSupply.gpsLatitude = Number(this.locationInfoForm.value.latitude);
      powerSupply.gpsLongitude = Number(this.locationInfoForm.value.longitude);
      //powerSupply.estimatedDesignRuntime = this.locationInfoForm.value.estimates;
      powerSupply.powersNode = this.locationInfoForm.value.powerNode;
      powerSupply.specialLocationDetails = this.locationInfoForm.value.spLocDetails;
      powerSupply.aerialUnderground = this.locationInfoForm.value.areial;
      powerSupply.powerAccountType = this.locationInfoForm.value.powerAccountType;
      powerSupply.poleNumber = this.locationInfoForm.value.pole;
      powerSupply.utilityProvider = this.locationInfoForm.value.powerCompany;
      powerSupply.companyAccountNumber = this.locationInfoForm.value.companyAccNum;
      powerSupply.powerCompanyContactNumber = this.locationInfoForm.value.companyContact;
      powerSupply.powerCompanyWebsite = this.locationInfoForm.value.companyWebsite
      //powerSupply.nwtTeam = this.locationInfoForm.value.nwtTeam;
      powerSupply.nwtTeam = this.nwtTeamData;
      powerSupply.nitroReasonNotCompleted = this.locationInfoForm.value.nitroReasonNotCompleted;
      powerSupply.nitroCompletionDate = this.locationInfoForm.value.nitroCompletionDate;
      powerSupply.electricMeterNumber = this.locationInfoForm.controls['meter'].value;;
      powerSupply.mapNumber = this.locationInfoForm.value.mapPageNumber;
      powerSupply.locationComments = this.locationInfoForm.value.locationComments;

      //Transponder Info
      powerSupply.powerSupplyType = this.transponderInfoForm.value.standByOpts;
      powerSupply.macAddress = this.transponderInfoForm.value.activeMacAddress;
      powerSupply.macAddressPrevious = this.transponderInfoForm.value.prevMacAddress;
      powerSupply.ip = this.transponderInfoForm.value.ip;
      powerSupply.powerSupplyNumber = this.transponderInfoForm.value.powerSupplyNum;
      powerSupply.nextGenNode = this.transponderInfoForm.value.nextGenNode;
      powerSupply.transponderVendor = this.transponderInfoForm.value.transponderVendor;
      powerSupply.transponderModel = this.transponderInfoForm.value.transponderModel;
      powerSupply.powerSupplyModel = this.transponderInfoForm.value.powerSupplyModel;
      powerSupply.acInputVoltage = this.transponderInfoForm.value.acInputVoltage;
      powerSupply.outputVoltage = this.transponderInfoForm.value.acOutputVoltage;
      powerSupply.inputCurrent = this.transponderInfoForm.value.currentAmp;
      //powerSupply.currentAmpOutput = this.transponderInfoForm.value.currentAmpOutput;
      powerSupply.serialNumber = this.transponderInfoForm.value.serialNum;
      //powerSupply.controllerCardType = this.transponderInfoForm.value.controlledCardType;
      powerSupply.dcReady = this.transponderInfoForm.value.dcReady;
      powerSupply.priority = this.transponderInfoForm.value.priority;
      powerSupply.egisName = this.transponderInfoForm.value.egisName;
      powerSupply.externalSensor = this.transponderInfoForm.value.externalSensor;
      powerSupply.transponderComments = this.transponderInfoForm.value.transponderComments;

      if (this.transponderInfoForm.value.powerSupplyType9360 !== null && this.transponderInfoForm.value.powerSupplyType9360 !== undefined) {
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Unknown') powerSupply.powerSupplyType9360 = '1';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Alpha XM2 - 120V') powerSupply.powerSupplyType9360 = '2';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Alpha XM2 - 240V') powerSupply.powerSupplyType9360 = '3';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Alpha XM - 120V') powerSupply.powerSupplyType9360 = '4';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Alpha XM - 240V') powerSupply.powerSupplyType9360 = '5';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Alpha AM/AP - 120V') powerSupply.powerSupplyType9360 = '6';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Alpha AM/AP - 220V') powerSupply.powerSupplyType9360 = '7';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Lectro (36V or 48V)ZTT - 120V') powerSupply.powerSupplyType9360 = '8';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Lectro (36V or 48V)ZTT - 240V') powerSupply.powerSupplyType9360 = '9';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Lectro ZTT+ - 120V') powerSupply.powerSupplyType9360 = '10';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Lectro ZTT+ - 240V') powerSupply.powerSupplyType9360 = '11';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Generic - 120V') powerSupply.powerSupplyType9360 = '12';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Generic - 240V') powerSupply.powerSupplyType9360 = '13';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Lectro CPR - 120V') powerSupply.powerSupplyType9360 = '14';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Lectro CPR - 240V') powerSupply.powerSupplyType9360 = '15';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Lectro 24VZTT - 120V') powerSupply.powerSupplyType9360 = '16';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'Lectro Sentry II') powerSupply.powerSupplyType9360 = '17';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'APC - 120V') powerSupply.powerSupplyType9360 = '18';
        if (this.transponderInfoForm.value.powerSupplyType9360 === 'APC - 240V') powerSupply.powerSupplyType9360 = '19';
      }

      //BatteryInfo
      powerSupply.numberOfBatteries = this.batteryInfoForm.value.numberofBatteries;
      powerSupply.batteriesReplaced = this.batteryInfoForm.value.batteriesReplaced;
      //powerSupply.airTemperature = this.batteryInfoForm.value.airTemperature;
      powerSupply.batteryComments = this.batteryInfoForm.value.batteryComments;
      powerSupply.batteryBalancerString = this.batteryInfoForm.value.batteryManagerModel;

      let preArray: any = [];
      let battArray: Array<number> = [];
      let k = 0;
      for (let i = 0; i < this.batteryStringForms.length; i++) {
        if (i == 0) {
          //powerSupply.batteryBalancerString1 = this.batteryStringForms.value[0].batteryManagerModel;
          //powerSupply.batterySeparatorPresent14 = this.batteryStringForms.value[0].batterySeparator;
        } else if (i == 1) {
          //powerSupply.batteryBalancerString2 = this.batteryStringForms.value[0].batteryManagerModel;
          //powerSupply.batterySeparatorPresent24 = this.batteryStringForms.value[0].batterySeparator;
        } else if (i == 2) {
          //powerSupply.batteryBalancerString3 = this.batteryStringForms.value[0].batteryManagerModel;
          //powerSupply.batterySeparatorPresent34 = this.batteryStringForms.value[0].batterySeparator;
        } else if (i == 3) {
          //powerSupply.batteryBalancerString4 = this.batteryStringForms.value[0].batteryManagerModel;
          //powerSupply.batterySeparatorPresent44 = this.batteryStringForms.value[0].batterySeparator;
        } else if (i == 4) {
          //powerSupply.batteryBalancerString5 = this.batteryStringForms.value[0].batteryManagerModel;
          //powerSupply.batterySeparatorPresent54 = this.batteryStringForms.value[0].batterySeparator;
        } else if (i == 5) {
          //powerSupply.batteryBalancerString6 = this.batteryStringForms.value[0].batteryManagerModel;
          //powerSupply.batterySeparatorPresent64 = this.batteryStringForms.value[0].batterySeparator;
        }
      }
      for (let i = 0; i < this.prvString; i++) {
        for (let j = 0; j < this.prvBattery; j++)
          preArray.push(i + '' + j)
      }
      //Logic for Parallel Batteries for Create PS
      let battStringCount = 1;
      let parallelBattsInString = 6;
      if(this.parallelBatt){
        for (let i = 0; i < battStringCount; i++) {
          for (let j = 0; j < parallelBattsInString; j++) {
            if (preArray.includes(i + '' + j)) {
              battArray.push(1);
            }
            else battArray.push(0);
          }
        }
        if (battArray[0] == 1) {
          powerSupply.type11 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial11 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate11 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage11 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload11 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance11 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected11 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString11 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate11 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[1] == 1) {
          powerSupply.type12 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial12 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate12 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage12 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload12 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance12 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected12 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString12 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate12 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[2] == 1) {
          powerSupply.type13 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial13 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate13 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage13 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload13 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance13 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected13 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate13 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[3] == 1) {
          powerSupply.type14 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial14 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate14 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage14 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload14 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance14 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected14 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate14 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[4] == 1) {
          powerSupply.type15 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial15 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate15 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage15 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload15 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance15 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected15 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          //powerSupply.totalVoltageString15 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate15 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[5] == 1) {
          powerSupply.type16 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial16 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate16 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage16 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload16 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance16 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected16 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          //powerSupply.totalVoltageString16 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate16 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }

      } else{
        for (let i = 0; i < 6; i++) {
          for (let j = 0; j < 4; j++) {
            if (preArray.includes(i + '' + j)) {
              battArray.push(1);
            }
            else battArray.push(0);
          }
        }
        if (battArray[0] == 1) {
          powerSupply.type11 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial11 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate11 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage11 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload11 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance11 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected11 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString11 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate11 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[1] == 1) {
          powerSupply.type12 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial12 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate12 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage12 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload12 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance12 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected12 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString12 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate12 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[2] == 1) {
          powerSupply.type13 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial13 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate13 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage13 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload13 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance13 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected13 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate13 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[3] == 1) {
          powerSupply.type14 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial14 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate14 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage14 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload14 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance14 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected14 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate14 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[4] == 1) {
          powerSupply.type21 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial21 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate21 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage21 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload21 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance21 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected21 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString21 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate21 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[5] == 1) {
          powerSupply.type22 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial22 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate22 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage22 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload22 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance22 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected22 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString22 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate22 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[6] == 1) {
          powerSupply.type23 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial23 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate23 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage23 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload23 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance23 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected23 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate23 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[7] == 1) {
          powerSupply.type24 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial24 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate24 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage24 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload24 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance24 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected24 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate24 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[8] == 1) {
          powerSupply.type31 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial31 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate31 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage31 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload31 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance31 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected31 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString31 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate31 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[9] == 1) {
          powerSupply.type32 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial32 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate32 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage32 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload32 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance32 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected32 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString32 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate32 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[10] == 1) {
          powerSupply.type33 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial33 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate33 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage33 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload33 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance33 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected33 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate33 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[11] == 1) {
          powerSupply.type34 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial34 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate34 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage34 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload34 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance34 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected34 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate34 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[12] == 1) {
          powerSupply.type41 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial41 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate41 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage41 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload41 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance41 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected41 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString41 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate41 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[13] == 1) {
          powerSupply.type42 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial42 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate42 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage42 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload42 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance42 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected42 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalVoltageString42 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate42 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[14] == 1) {
          powerSupply.type43 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial43 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate43 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage43 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload43 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance43 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected43 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate43 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[15] == 1) {
          powerSupply.type44 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial44 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate44 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage44 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload44 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance44 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected44 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate44 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[16] == 1) {
          powerSupply.type51 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial51 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate51 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage51 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload51 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance51 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected51 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring51 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate51 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[17] == 1) {
          powerSupply.type52 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial52 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate52 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage52 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload52 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance52 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected52 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring52 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate52 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[18] == 1) {
          powerSupply.type53 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial53 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate53 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage53 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload53 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance53 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected53 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring53 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate53 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[19] == 1) {
          powerSupply.type54 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial54 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate54 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage54 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload54 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance54 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected54 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring54 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate54 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[20] == 1) {
          powerSupply.type61 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial61 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate61 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage61 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload61 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance61 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected61 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring61 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate61 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[21] == 1) {
          powerSupply.type62 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial62 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate62 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage62 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload62 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance62 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected62 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring62 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate62 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[22] == 1) {
          powerSupply.type63 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial63 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate63 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage63 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload63 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance63 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected63 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring63 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate63 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
        if (battArray[23] == 1) {
          powerSupply.type64 = this.batteryBatteryForms.value[k].batteryManufacturer;
          powerSupply.batterySerial64 = this.batteryBatteryForms.value[k].batterySerial;
          powerSupply.manufactureDate64 = this.batteryBatteryForms.value[k].batteryCode;
          powerSupply.voltage64 = this.batteryBatteryForms.value[k].batteryVoltageNoLoad;
          powerSupply.batteryVoltageUnderload64 = this.batteryBatteryForms.value[k].batteryVoltageUnderLoad;
          powerSupply.batteryConductance64 = this.batteryBatteryForms.value[k].batteryConductance;
          powerSupply.batteryConductanceCorrected64 = this.batteryBatteryForms.value[k].batteryConductanceCorrected;
          powerSupply.totalvoltagestring64 = this.batteryBatteryForms.value[k].totalVoltage;
          if (this.batteryBatteryForms.value[k].batteryInstallDate != null && this.batteryBatteryForms.value[k].batteryInstallDate != undefined && this.batteryBatteryForms.value[k].batteryInstallDate != '') {
            const date = new Date(this.batteryBatteryForms.value[k].batteryInstallDate);
            powerSupply.installDate64 = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
          }
          k++;
        }
      }

      //LastVistInfo
      if (this.lastVisitInfoForm.value.inspectionDate !== '' && this.lastVisitInfoForm.value.inspectionDate != null && this.lastVisitInfoForm.value.inspectionDate != undefined) {
        const date = new Date(this.lastVisitInfoForm.value.inspectionDate);
        powerSupply.inspectionDate = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
      } else {
        powerSupply.inspectionDate=null;
      }
      powerSupply.typeOfVisit = this.lastVisitInfoForm.value.typeOfVisit;
      //powerSupply.xocVerified = this.lastVisitInfoForm.value.xocVerified;
      powerSupply.xocVerified = (this.disableSaveButton) ? "Yes" : '';
      powerSupply.cleanEnclosure = this.lastVisitInfoForm.value.cleanDust;
      powerSupply.tightenHardware = this.lastVisitInfoForm.value.tightenAll;
      //powerSupply.inspectConnectors = this.lastVisitInfoForm.value.inspectWire;
      powerSupply.inspectConnectors = (this.disableSaveButton) ? "Yes" : '';
      //powerSupply.inspectProbes = this.lastVisitInfoForm.value.inspectBattery;
      powerSupply.inspectProbes = (this.disableSaveButton) ? "Yes" : '';
      powerSupply.meterPanCondition = this.lastVisitInfoForm.value.meterPan;
      //powerSupply.powerCoRiserCondition = this.lastVisitInfoForm.value.powerCo;
      powerSupply.powerCoRiserCondition = (this.disableSaveButton) ? "Good" : '';
      // powerSupply.batteryHeaterMatType = this.lastVisitInfoForm.value.batteryHeaterType;
      // powerSupply.batteryHeaterMatQuantity = this.lastVisitInfoForm.value.batteryHeaterQuantity;
      // powerSupply.enclosureSnowShield = this.lastVisitInfoForm.value.encloseSnow;
      // powerSupply.internalBreaker = this.lastVisitInfoForm.value.internalBreaker;
      // powerSupply.serviceEntrance = this.lastVisitInfoForm.value.serviceEntrance;
      // powerSupply.receptacleType = this.lastVisitInfoForm.value.receptacleType;
      // powerSupply.checkSeizureAltBox = this.lastVisitInfoForm.value.checkSeizure;
      // powerSupply.powerSupplyIdLegible = this.lastVisitInfoForm.value.psIDLegibile;
      // powerSupply.checkLampsLeds = this.lastVisitInfoForm.value.checkLamps;
      // powerSupply.checkMagneticBreaker = this.lastVisitInfoForm.value.checkCircuitBreaker;
      // powerSupply.visualCabinetInspection = this.lastVisitInfoForm.value.visualInspection;
      powerSupply.serviceEntrance = '';
      powerSupply.receptacleType = this.lastVisitInfoForm.value.receptacleType;
      //powerSupply.checkSeizureAltBox = this.lastVisitInfoForm.value.checkSeizure;
      powerSupply.checkSeizureAltBox = (this.disableSaveButton) ? "Ok" : '';
      //powerSupply.powerSupplyIdLegible = this.lastVisitInfoForm.value.psIDLegibile;
       powerSupply.powerSupplyIdLegible = (this.disableSaveButton) ? "Yes" : '';
      //powerSupply.checkLampsLeds = this.lastVisitInfoForm.value.checkLamps;
      powerSupply.checkLampsLeds = (this.disableSaveButton) ? "Ok" :'';
      //powerSupply.checkMagneticBreaker = this.lastVisitInfoForm.value.checkCircuitBreaker;
      powerSupply.checkMagneticBreaker = (this.disableSaveButton) ? "Ok" :'';
      powerSupply.visualCabinetInspection = (this.disableSaveButton) ? "Ok" : '';
      powerSupply.cabinetLocked = this.lastVisitInfoForm.value.cabinetLocked;
      //powerSupply.securityBarPresent = this.lastVisitInfoForm.value.securityBar;
      powerSupply.checkGroundCabinet = this.lastVisitInfoForm.value.checkGround;

      // powerSupply.batteryString1Fused = this.lastVisitInfoForm.value.batteryStringFused1;
      // powerSupply.batteryString2Fused = this.lastVisitInfoForm.value.batteryStringFused2;
      // powerSupply.batteryString3Fused = this.lastVisitInfoForm.value.batteryStringFused3;
      // powerSupply.batteryString4Fused = this.lastVisitInfoForm.value.batteryStringFused4;

      // powerSupply.batteryString5Fused = this.lastVisitInfoForm.value.batteryStringFused5;
      // powerSupply.batteryString6Fused = this.lastVisitInfoForm.value.batteryStringFused6;

      powerSupply.tamperInstalledFunctioning = this.lastVisitInfoForm.value.tamperInstalled;
      //powerSupply.checkLaps = this.lastVisitInfoForm.value.checkLaps;
      powerSupply.checkLaps = (this.disableSaveButton) ? "Ok" : '';
      powerSupply.cabinetVendor = this.lastVisitInfoForm.value.cabinetVendor;
      powerSupply.cabinetBatteryCapacity = this.lastVisitInfoForm.value.cabinetBattery;
      //powerSupply.checkOperatingLights = this.lastVisitInfoForm.value.checkOperating;
      powerSupply.checkOperatingLights = (this.disableSaveButton) ? "Ok" : '';
      //powerSupply.followUpNeeded = this.lastVisitInfoForm.value.followUp;
      powerSupply.inputSurgeArrestor = this.lastVisitInfoForm.value.inputSurge;
      powerSupply.outputSurgeArrestor = this.lastVisitInfoForm.value.outputSurge;
      // powerSupply.coaxTvssPresent = this.lastVisitInfoForm.value.coaxTvss;
      powerSupply.acIndicatorGreenLight  = (this.disableSaveButton) ? "Ok" : '';
      // powerSupply.localRemoteIndicator = this.lastVisitInfoForm.value.lri;
      powerSupply.localRemoteIndicator = (this.disableSaveButton) ? "Yes" : '';
      powerSupply.comments = this.lastVisitInfoForm.value.lastVisitComments;
      powerSupply.followUpReason = this.lastVisitInfoForm.value.followUpReasons;

      //misc
      powerSupply.nodeId = this.nodeId;
      powerSupply.powerSupplyName = this.powerSupplyName;
      this.nodesServed = this.nodeName;
      for (let i = 0; i < this.nodeValues.length; i++) {
        if (this.nodeValues[i] !== undefined) {
          if (this.nodeValues[i] !== null && this.nodeValues[i] !== '' && this.nodesServed !== '') {
            this.nodesServed = this.nodesServed.concat(' ', this.nodeValues[i]);
          }
          else {
            this.nodesServed = this.nodesServed.concat(this.nodeValues[i]);
          }
        }
      }
      if (this.nodesServed !== null || this.nodesServed !== '') {
        powerSupply.nodesServed = this.nodesServed;
      }
      powerSupply.alertProfile = this.powerSupplyAlertProfile;
      powerSupply.alertProfileException = this.powerSupplyAlertProfile;
      powerSupply.psAlertProfile = this.powerSupplyAlertProfile;
      powerSupply.sysLocation = this.sysLocation;
      powerSupply.sysContact = this.sysContact;
      powerSupply.logDate = new Date().toISOString();
      powerSupply.dateEntered = new Date().toISOString();
      powerSupply.logNt = this.authService.getUserDetails.userName;
      if (this.authService.getUserDetails.lastName && this.authService.getUserDetails.firstName) {
        powerSupply.logName = this.authService.getUserDetails.lastName + ', ' + this.authService.getUserDetails.firstName;
        powerSupply.commTech = this.authService.getUserDetails.lastName + ', ' + this.authService.getUserDetails.firstName;
      } else {
        powerSupply.logName = this.msalService.instance?.getActiveAccount()?.name;
        powerSupply.commTech = powerSupply.logName;
      }
      nodePowersupply.name = this.nodeName;
      powerSupply.node = nodePowersupply;

      if (this.transponderInfoForm.value.powerSupplyNum === '001') {
        powerSupply.deviceId = '1';
      }
      else if (this.transponderInfoForm.value.powerSupplyNum === '002') {
        powerSupply.deviceId = '2';
      }
      else if (this.transponderInfoForm.value.powerSupplyNum === '003') {
        powerSupply.deviceId = '3';
      }
      else if (this.transponderInfoForm.value.powerSupplyNum === '004') {
        powerSupply.deviceId = '4';
      }
      else if (this.transponderInfoForm.value.powerSupplyNum === '005') {
        powerSupply.deviceId = '5';
      }

      if (this.userDetails.permissions.includes('{1091}')) {
        this.permissionValue = true;
      } else {
        this.permissionValue = false;
      }
      //1091 permission will go normal ps edit otherwise it will go triage table
      if (this.permissionValue) {
        //Post call  - for Comcast user
        this.showProgressspinner = true;
        this.powerSupplyService.createPowerSupply(powerSupply)
          .subscribe(result => {
            if (result.success === true) {
              const activity = 'PowerSupply Create Save';
              const message = `PowerSupply Create Save Success. PowerSupply Data: ${JSON.stringify(powerSupply)}`;
              this.commonService.loggerPost(message, activity, 3);
            } else {
              const activity = 'PowerSupply Create Save';
              const message = `PowerSupply Create Save Error. Error: ${result.message}. PowerSupply Data: ${JSON.stringify(powerSupply)}`;
              this.commonService.loggerPost(message, activity, 3);
            }
            if (result.success === true) {
              this.powerSupplyService.getPowerSupplyByMAC(powerSupply.macAddress)
              .subscribe(data => {
                if (data.powerSupplyId != null && data.powerSupplyId != 0) {
                  //save SFP data by getting value from localstorage
                  let localstorageSfp = JSON.parse(localStorage.getItem('powerSupplySfp'));
                  if(localstorageSfp && (localstorageSfp !== "" || localstorageSfp !== null)){
                    localstorageSfp['powerSupplyId'] = data.powerSupplyId;
                    //saving SFP
                     this.saveSfp(localstorageSfp);
                  }

                }
                });
              //if any changes or upload in the file section
               if ((this.file !== null && this.file !== undefined) || this.submitFlag) {
                if(this.submitFlag){
                  this.filearray = JSON.parse(localStorage.getItem('filearray'));
                  console.log(this.filearray);
                }
                //this.psFileUpload(powerSupply, result.message);
                this.powerSupplyService.getPowerSupplyByMAC(powerSupply.macAddress)
                  .subscribe(data => {
                    if (data.powerSupplyId != null && data.powerSupplyId != 0) {
                      let imageRequest: ImageMetaDataUpdateRequest;
                      var categoryValue = [];
                      for (let i = 0; i < this.filearray.length; i++) {
                        categoryValue.push(this.filearray[i]['id']);
                      }
                      imageRequest = {
                        triageId: null,
                        powerSupplyId: data.powerSupplyId,
                        macAddress: powerSupply.macAddress,
                        categories: categoryValue,
                        actionType: 'Create'
                      };
                      this.powerSupplyService.updatePSIDAndTriageIDByMacAndCategory(imageRequest).subscribe(res => {
                        if (res.success === true) {
                          const activity = 'PowerSupply Image PSID & TriageID Update';
                          const message = `PowerSupply Image PSID & TriageID Update Success. PowerSupply Image Category Data: ${JSON.stringify(categoryValue)}`;
                          this.commonService.loggerPost(message, activity, 3);
                          this.showProgressBar = false;
                          this.openCreatedDialog(result.message);
                          //once ps created removed all the picture in local storage
                          this.removePictureStorage();
                        } else {
                          const activity = 'PowerSupply Image PSID & TriageID Update';
                          const message = `PowerSupply Image PSID & TriageID Update Error. Error: ${res.message}. PowerSupply Image Category Data: ${JSON.stringify(categoryValue)}`;
                          this.commonService.loggerPost(message, activity, 5);
                          this.showProgressBar = false;
                          this.showProgressspinner = false;
                          this.openErrorDialog("Something went wrong. Please try later !!");
                        }
                      }, err => {
                        this.showProgressBar = false;
                        this.showProgressspinner = false;
                        this.openErrorDialog("Something went wrong. Please try later !!");
                      });
                    }
                  });
                  this.showProgressspinner = false;
              } else {
                this.showProgressspinner = false;
                this.openCreatedDialog(result.message);
              }
            } else if (result.success === false && result.message.toUpperCase() === 'EXISTS') {
              this.showProgressspinner = false;
              this.openNameExistsDialog();
              this.ref.detectChanges();
              //button enabled for save
              this.data.createsave('createlocform', "false");
            } else if (result.success === false && result.message) {
              this.showProgressspinner = false;
              this.openErrorDialog(result.message);
              this.ref.detectChanges();
              //button enabled for save
              this.data.createsave('createlocform', "false");
            } else {
              this.showProgressspinner = false;
              this.openErrorDialog("Something went wrong. Please try later !!");
            }
          }, err => {
            this.showProgressspinner = false;
            this.openErrorDialog("Something went wrong. Please try later !!");
            setTimeout(() => {
              this.showProgressspinner = false;
              this.data.createsave('createlocform', "false");
            });
          });
      } else {
        this.showProgressspinner = true;
        //copy the ps object into pstriage
        let PowerSupplyTriage = JSON.parse(JSON.stringify(powerSupply))
        PowerSupplyTriage.phoneNo = this.lastVisitInfoForm.value.mobileno;
        //for non comcast user
        this.powerSupplyService.createPowerSupplyForNonComcastUsers(PowerSupplyTriage)
          .subscribe(result => {
            if (result.responseStatus.success === true) {
              const activity = 'PowerSupply Create Save';
              const message = `PowerSupply Create Save Success. PowerSupply Data: ${JSON.stringify(powerSupply)}`;
              this.commonService.loggerPost(message, activity, 3);
            } else {
              const activity = 'PowerSupply Create Save';
              const message = `PowerSupply Create Save Error. Error: ${result.responseStatus.message}. PowerSupply Data: ${JSON.stringify(powerSupply)}`;
              this.commonService.loggerPost(message, activity, 3);
            }

            if (result.responseStatus.success === true) {
               //addding triageId to local storage
               let localstorageSfp = JSON.parse(localStorage.getItem('powerSupplySfp'));
               if (localstorageSfp && (localstorageSfp !== "" || localstorageSfp !== null)) {
                 localstorageSfp['triageId'] = result.triageId;
                 localstorageSfp['powerSupplyId'] = 0;
                 localStorage.setItem('powerSupplySfp', JSON.stringify(localstorageSfp));
                  //saving SFP
                 this.saveSfpTriage(localstorageSfp);
               }
              if ((this.file !== null && this.file !== undefined) || this.submitFlag) {

                if(this.submitFlag){
                  this.filearray = JSON.parse(localStorage.getItem('filearray'));
                  console.log(this.filearray);
                }
                //this.psFileUploadnoncomcast(result.triageId, PowerSupplyTriage, result.responseStatus.message);
                let imageRequest: ImageMetaDataUpdateRequest;
                var categoryValue = [];
                for (let i = 0; i < this.filearray.length; i++) {
                  categoryValue.push(this.filearray[i]['id']);
                }
                imageRequest = {
                  triageId: result.triageId,
                  powerSupplyId: result.powerSupplyId,
                  macAddress: result.macAddress,
                  categories: categoryValue,
                  actionType: 'Create'
                };
                this.powerSupplyService.updatePSIDAndTriageIDByMacAndCategory(imageRequest).subscribe(res => {
                  if (res.success === true) {
                    const activity = 'PowerSupply Image PSID & TriageID Update';
                    const message = `PowerSupply Image PSID & TriageID Update Success. PowerSupply Image Category Data: ${JSON.stringify(categoryValue)}`;
                    this.commonService.loggerPost(message, activity, 3);
                    this.showProgressBar = false;
                    this.showProgressspinner = false;
                    this.openCreatedDialog(result.responseStatus.message, true);
                    //once ps created removed all the picture in local storage
                    this.removePictureStorage();
                  } else {
                    const activity = 'PowerSupply Image PSID & TriageID Update';
                    const message = `PowerSupply Image PSID & TriageID Update Error. Error: ${res.message}. PowerSupply Image Category Data: ${JSON.stringify(categoryValue)}`;
                    this.commonService.loggerPost(message, activity, 5);
                    this.showProgressBar = false;
                    this.showProgressspinner = false;
                    this.openErrorDialog("Something went wrong. Please try later !!");
                  }
                }, err => {
                  this.showProgressBar = false;
                  this.showProgressspinner = false;
                  this.openErrorDialog("Something went wrong. Please try later !!");
                });
              } else {
                this.showProgressspinner = false;
                this.openCreatedDialog(result.responseStatus.message, true);
              }
            } else if (result.responseStatus.success === false && result.responseStatus.message.toUpperCase() === 'EXISTS') {
              this.showProgressspinner = false;
              this.openNameExistsDialog();
              this.ref.detectChanges();
              //button enabled for save
              this.data.createsave('createlocform', "false");
            } else if (result.responseStatus.success === false && result.responseStatus.message) {
              this.showProgressspinner = false;
              this.openErrorDialog(result.responseStatus.message);
              this.ref.detectChanges();
              //button enabled for save
              this.data.createsave('createlocform', "false");
            } else {
              this.showProgressspinner = false;
              this.openErrorDialog("Something went wrong. Please try later !!");
            }
          }, err => {
            this.showProgressspinner = false;
            this.openErrorDialog("Something went wrong. Please try later !!");
          });
      }
    }
  }

  public openNameExistsDialog() {
    this.powerSupplyNameDialog = this.dialog.open(PowerSupplyNameDialog, {
      data: {
        powerSupplyName: this.powerSupplyName ? this.powerSupplyName : ''
      },
      disableClose: true
    });
    this.powerSupplyNameDialog.afterClosed().subscribe(res => res);
  }

  openCreatedDialog(name: string, nonComcast: boolean = false) {
    this.powerSupplyCreatedDialog = this.dialog.open(PowerSupplyCreatedDialog, {
      data: {
        powerSupplyName: name ? name : '',
        nodeId: this.nodeId,
        nonComcast: nonComcast
      },
      disableClose: true
    });
  }

  openErrorDialog(message: string) {
    this.powerSupplyMoveErrorDialog = this.dialog.open(PowerSupplyMoveErrorDialog, {
      data: {
        message: message ? message : '',
      },
      disableClose: true
    })
    this.powerSupplyMoveErrorDialog.afterClosed().subscribe(res => res);
  }

  openUploadDialog(message: string) {
    this.uploadDialog = this.dialog.open(UploadDialog, {
      data: {
        message: message ? message : ''
      },
      disableClose: true
    })
    this.uploadDialog.afterClosed().subscribe(() => {});
  }

  onChangeSysLocation() {

    if (this.locationInfoForm.value.mapPageNumber !== undefined && this.locationInfoForm.value.mapPageNumber !== null) {
      this.mapNumber = this.locationInfoForm.value.mapPageNumber;
    }

    if (this.locationInfoForm.value.latitude !== undefined && this.locationInfoForm.value.latitude !== null) {
      this.gpsLatitude = this.locationInfoForm.value.latitude;
    }

    if (this.locationInfoForm.value.longitude !== undefined && this.locationInfoForm.value.longitude !== null) {
      this.gpsLongitude = this.locationInfoForm.value.longitude;
    }

    if (this.locationInfoForm.value.powerNode !== undefined && this.locationInfoForm.value.powerNode !== null) {
      this.powersNode = this.locationInfoForm.value.powerNode;
    }

    if (this.locationInfoForm.value.spLocDetails !== undefined && this.locationInfoForm.value.spLocDetails !== null) {
      this.desc = this.locationInfoForm.value.spLocDetails.trim();
    }
    if (this.locationInfoForm.value.businessPartnerRestriction !== undefined && this.locationInfoForm.value.businessPartnerRestriction !== null) {
      this.businessPartnerRestriction = this.locationInfoForm.value.businessPartnerRestriction;
      if (this.locationInfoForm.value.businessPartnerRestriction === "Other") {
        this.locationInfoForm.controls["locationComments"].setValidators(Validators.required);
        this.locationInfoForm.controls["locationComments"].updateValueAndValidity();
      }
      else {
        this.locationInfoForm.controls["locationComments"].clearValidators();
        this.locationInfoForm.controls["locationComments"].updateValueAndValidity();
      }
    }

    if (this.transponderInfoForm.value.priority !== undefined && this.transponderInfoForm.value.priority !== null) {
      this.priority = this.transponderInfoForm.value.priority.trim();
    }
    this.sysLocation = "NODES#" + this.nodeName + "-" + this.node2 + "-" + this.node3 + "-" + this.node4 + "-" + this.node5 + "_MAP#" + this.mapNumber + "_LAT#" + this.gpsLatitude + "_LONG#" + this.gpsLongitude + "_DETAILS#" + this.desc + "_RUNS NODE#" + this.powersNode + "_PRIORITY " + this.priority;
  }

  onChangeSysContact() {
    if (this.locationInfoForm.value.pole !== undefined && this.locationInfoForm.value.pole !== null) {
      this.poleNumber = this.locationInfoForm.value.pole;
    }
    if (this.locationInfoForm.value.houseNumberInput !== undefined && this.locationInfoForm.value.houseNumberInput !== null) {
      this.houseNumber = this.locationInfoForm.value.houseNumberInput;
    }
    if (this.locationInfoForm.value.street !== undefined && this.locationInfoForm.value.street !== null) {
      this.street = this.locationInfoForm.value.street;
    }
    if (this.locationInfoForm.value.crossStreet !== undefined && this.locationInfoForm.value.crossStreet !== null) {
      this.crossStreet = this.locationInfoForm.value.crossStreet;
    }
    if (this.locationInfoForm.value.city !== undefined && this.locationInfoForm.value.city !== null) {
      this.city = this.locationInfoForm.value.city;
    }
    if (this.locationInfoForm.value.state !== undefined && this.locationInfoForm.value.state !== null) {
      if (this.locationInfoForm.value.state != this.state) {
        this.standByOptions = [];
        if(this.locationInfoForm.value.state != 'CA' && this.transponderInfoForm.value.standByOpts == 'CPUC - StandBy')
          this.transponderInfoForm.controls.standByOpts.setValue('');
        this.powerSupplyService.getStandByOptionsByState(this.locationInfoForm.value.state).subscribe(res => {
          res.forEach(result => this.standByOptions.push(result.standbyOptions));
        });
      }
      this.state = this.locationInfoForm.value.state;
      if((this.nodeName != '' || this.nodeName != null) && this.state != ''){
        this.powerSupplyService.getNWTTeams(this.nodeName,this.state).subscribe(resultdata => {
          this.nwtTeamData = resultdata['nwtTeam'];
          this.locationInfoForm.controls['nwtTeam'].patchValue(this.nwtTeamData);
        });
      }
    }
    if (this.locationInfoForm.value.state == undefined && this.locationInfoForm.value.state == null) {
      this.standByOptions = [];
      this.powerSupplyService.getStandByOptionsByState('').subscribe(res => {
        res.forEach(result => this.standByOptions.push(result.standbyOptions));
      });
      this.state = this.locationInfoForm.value.state;
    }
    if (this.region == 'Boston Region') {
      if (this.crossStreet !== '') {
        this.sysContact = "POLE#" + this.poleNumber + "_" + this.houseNumber + " " + this.street + " X " + this.crossStreet + "_" + this.city + ", " + this.state;
      }
      else this.sysContact = "POLE#" + this.poleNumber + "_" + this.houseNumber + " " + this.street + "_" + this.city + ", " + this.state;
    } else this.sysContact = this.houseNumber + " " + this.street + " X " + this.crossStreet + "_" + this.city + ", " + this.state;
  }

  onChangePowerSupplyNum() {
    let psn = '';
    if (this.transponderInfoForm.value.powerSupplyNum !== ''
      && this.transponderInfoForm.value.powerSupplyNum !== undefined
      && this.transponderInfoForm.value.powerSupplyNum !== null) {
      psn = '-' + this.transponderInfoForm.value.powerSupplyNum.trim();
    }
    if (psn === '') psn = '-' + '';
    this.powerSupplyName = this.basePowerSupplyName + psn;
  }

  getBatteryNumber(j) {
    return j % this.noOfBatteries + 1;
  }

  validateFiberNodes() {
    this.validateFN = !this.validateFN;
    for (let i = 0; i < this.nodesForms.length; i++) {
      if (this.nodesForms.at(i).value.node != null && this.nodesForms.at(i).value.node !== '' && this.nodesForms.at(i).value.node !== undefined) {
        if (this.validateFN)
          this.filterNodeOptions[i] = this.nodeService.resourceNodeServiceResourceAdvancedSearchGET(this.nodesForms.at(i).value.node).pipe(shareReplay({refCount:true,bufferSize:1}),map(res => res));
        else
          this.filterNodeOptions[i] = this.nodeService.resourceNodeServiceResourceAdvancedSearchGET(this.nodesForms.at(i).value.node).pipe(shareReplay({refCount:true,bufferSize:1}),map(res => res.filter((item: JsonAdvancedSearchResult) => item.nodeCommunintyServed === this.communityServed)));
        this.filterNodeOptions[i].subscribe(nodes => {
          if (nodes.length > 0 && nodes.find(x => x.node.toUpperCase() == this.nodesForms.at(i).value.node.toUpperCase())) {
            this.nodesForms.at(i).get('node').setErrors(null);
            this.updateForm(this.nodesForms.at(i).value.node, i);
          } else {
            this.nodesForms.at(i).get('node').markAsDirty();
            this.nodesForms.at(i).get('node').markAsTouched();
            this.nodesForms.at(i).get('node').setErrors({ nodeError: true });
          }
        });
      }
    }
  }

  mobilenopattern(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    let trimmed = input.value.replace(/\s+/g, "");

    if (trimmed.length > 12) {
      trimmed = trimmed.substr(0, 12);
    }

    trimmed = trimmed.replace(/-/g, "");

    let numbers = [];
    numbers.push(trimmed.substr(0, 3));
    if (trimmed.substr(3, 3) !== "") numbers.push(trimmed.substr(3, 3));
    if (trimmed.substr(6, 4) != "") numbers.push(trimmed.substr(6, 4));
    input.value = numbers.join("-");
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  titleCase(string) {
    var sentence = string.toLowerCase().split(" ");
    for(var i = 0; i< sentence.length; i++){
      sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    }
    return sentence.join(" ");
  }

  trimLeadingAndTrailingSpaces(formControl: AbstractControl) {
    if (formControl && formControl.value && typeof formControl.value === 'string') {
        formControl.setValue(formControl.value.trim());
    }
  }

  omit_special_char(event){
    if (event.target.value !== '') {
      if (this.mac_address == '') {
        this.remcolon = event.target.value.toString().replace(/:/g, "");
        let remcolonupdate = this.remcolon.replace(/\s/g, "");
        const blocks = remcolonupdate.match(/.{1,2}/g);
        let formattedMac = blocks.shift();
        for (const block of blocks) {
          formattedMac = formattedMac + ':' + block;
        }
        this.mac_address = formattedMac;
      } else {
        this.remcolon = event.target.value.toString().replace(/:/g, "");
        let remcolonupdate = this.remcolon.replace(/\s/g, "");
        const blocks = remcolonupdate.match(/.{1,2}/g);
        let formattedMac = blocks.shift();
        for (const block of blocks) {
          formattedMac = formattedMac + ':' + block;
        }
        this.mac_address = formattedMac;
      }
    }

    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 58));
  }


  saveSfp(localstorageSfp){
    this.powerSupplyService.createPowerSupplySfp(localstorageSfp).subscribe(res => {
     // this.onChangeSfpMac(this.sfpsupplyFormGroup.value.sfpMac);
      this.showProgressBar = false;
      localStorage.removeItem('powerSupplySfp');
    },err => {
      this.showProgressBar = false;
    });
  }


  onChangeNextgenType(){
    let event = this.transponderInfoForm.value.nextGenNode;
    if (event !== null && event !== undefined && event !== '') {
      this.selectedPSType = event;
       if (this.selectedPSType === 'EPON with SFP') {
        this.showsfp= true;
        setTimeout(() => {
          if(this.transponderInfoForm.value.activeMacAddress == ""){
            this.transponderInfoForm.controls['sfpMac'].patchValue('')
          }
        });
      }else{
        this.showsfp = false;
      }
    }
  }

  openSupplyDialog(supplyNumber: number) {
    this.supplyComponent = this.dialog.open(PowerSupplyCreateComponent, {
      panelClass: 'my-centered-dialog',
      disableClose: true,
      height: '50%',
      data: {
        id: this.powerSupplyId,
        noOfBatteries:this.batteryInfoForm.value.numberofBatteries,
        division:this.division,
        supplyNumber: supplyNumber,
        ampRatings:this.ampRatings,
        powerSupplyModels: this.powerSupplyModels,
        controlCardTypes: this.cardTypes,
        supplyName: this.powerSupplyName,
        sysContact: this.sysContact,
        sysLocation: this.sysLocation,

      }
    });

    this.supplyComponent.afterClosed().subscribe(result => {
      if (result === 'CREATED') this.openDialog("Supply Information Created Sucessfully !!");
      else if (result === 'UPDATED') this.openDialog("Supply Information Updated Sucessfully !!");
      else if (result !== 'OK') this.openDialog("Something went wrong. Please try later !!");
    });
  }


  openSupplyDialogsfp() {
    this.sfpsupplyComponent = this.dialog.open(PowerSupplyEditSupplysfpComponent, {
      panelClass: 'my-centered-dialog',
      disableClose: true,
      height: '50%',
      data: {
        id: this.powerSupplyId,
        division:this.division,
        //supplyNumber: supplyNumber,
        ampRatings:this.ampRatings,
        powerSupplyModels: this.powerSupplyModels,
        controlCardTypes: this.cardTypes,
        supplyName: this.powerSupplyName,
        sysContact: this.sysContact,
        sysLocation: this.sysLocation,
        triageId: this.triageId
      }
    });

    this.sfpsupplyComponent.afterClosed().subscribe(result => {
      if (result === 'CREATED') this.openDialog("SFP Information Created Sucessfully !!");
      else if (result === 'UPDATED') this.openDialog("SFP Information Updated Sucessfully !!");
      else if (result !== 'OK') this.openDialog("Something went wrong. Please try later !!");
    });
  }


  // onChangeAccType(event){
  //   if(event === 'Metered'){
  //     this.showMeter = true;
  //     this.locationInfoForm.controls["meter"].setValue('');
  //     this.locationInfoForm.get('meter').enable();
  //   }else if(event === 'Un-Metered'){
  //     this.showMeter = true;
  //     //this.locationInfoForm.controls["meter"].setValue('Un-Metered');
  //     this.locationInfoForm.controls["meter"].setValue('');
  //     this.locationInfoForm.get('meter').enable();
  //   }else{
  //     this.showMeter = true;
  //     this.locationInfoForm.controls["meter"].setValue('');
  //     this.locationInfoForm.get('meter').enable();
  //   }
  // }

  //Values for Location Info
  states: string[] = [''];
  nodeFeeds: string[] = ['',
  'No',
  'Yes - 2 Nodes',
  'Yes - 3 Nodes',
  'Yes - 4 Nodes',
  'Yes - 5 Nodes',
  'Yes - 6 Nodes',
  'Yes - 7 Nodes',
  'Yes - 8 Nodes',
  'Yes - 9 Nodes',
  'Yes - 10 Nodes',
  'Yes - 11 Nodes',
  'Yes - 12 Nodes',
  'Yes - 13 Nodes',
  'Yes - 14 Nodes',
  'Yes - 15 Nodes',
  'Yes - 16 Nodes',
  'Yes - 17 Nodes',
  'Yes - 18 Nodes',
  'Yes - 19 Nodes',
  'Yes - 20 Nodes',
  'Yes - 21 Nodes',
  'Yes - 22 Nodes',
  'Yes - 23 Nodes',
  'Yes - 24 Nodes',
  'Yes - 25 Nodes',
  'Yes - 26 Nodes',
  'Yes - 27 Nodes',
  'Yes - 28 Nodes',
  'Yes - 29 Nodes',
  'Yes - 30 Nodes',
  'Yes - 31 Nodes',
  'Yes - 32 Nodes'];
  nodePowers: string[] = [''];
  businessPartneRestrictions: string[] = [''];
  UGs: string[] = ['']
  powerCompanies: string[] = [''];
  nwtTeams: string[] = [''];
  nodes: string[] = ['One', 'Two', 'Three'];
  //estimates: string[] = [''];
  acctypes: string[] = [''];
  //Values for TransponderInfo
  standByOptions: string[] = [];
  //standByOptions: string[] = ['']
  PSNOptions: string[] = [''];
  PSNOptionsOther: string[] = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  PSNFreedomOptions: string[] = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'BB', 'CC', 'DD', 'EE', 'FF', 'GG', 'HH', 'II', 'JJ'];
  PSKeyStoneEastOptions: string[] = ['', '0', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  PSKeyStoneWestOptions: string[] = ['', '001', '002', '003', '004', '005', '006', '007', '008', '009', '010', '011', '01A-gen', '01B', '01C', '01D', '01E', '012', '02A-gen', '02B', '02C', '02D', '02E', '03A-gen', '03B', '03C', '03D', '03E', '04A-gen', '04B', '04C', '04D', '04E', '05A-gen', '05B', '05C', '05D', '05E'];
  transponderVendors: string[] = [''];
  transponderModels: string[] = [''];
  powerSupplyModels: string[] = [''];
  // powerSupplyTypes: string[] = ['Unknown', 'Alpha XM2 - 120V', 'Alpha XM2 - 240V', 'Alpha XM - 120V', 'Alpha XM - 240V', 'Alpha AM/AP - 120V', 'Alpha AM/AP - 220V',
  //   'Lectro (36V or 48V)ZTT - 120V', 'Lectro (36V or 48V)ZTT - 240V', 'Lectro ZTT+ - 120V', 'Lectro ZTT+ - 240V', 'Generic - 120V', 'Generic - 240V', 'Lectro CPR - 120V',
  //   'Lectro CPR - 240V', 'Lectro 24VZTT - 120V', 'Lectro Sentry II', 'APC - 120V', 'APC - 240V']
  inputVoltageRatings: string[] = [''];
  outputVoltageRatings: string[] = [''];
  ampRatings: string[] = [''];
  ampOutputRatings: string[] = [''];
  cardTypes: string[] = [''];
  DCReadyDecisions: string[] = [''];
  externalSensors: string[] = ['Yes', 'No'];
  // Values for LastVisit
  //visitTypes: string[] = ['', 'Annual Inspection', 'Maintenance', 'Repair', 'Outage', 'Nitro'];
  visitTypes:string[]=[];
  // cleanDustOptions: string[] = ['', 'Yes', 'No'];
  // hardwareTightenOptions: string[] = ['', 'Yes', 'No'];
  // wireInspectionOption: string[] = ['', 'Yes', 'No'];
  // batteryTemperatureInspectionOptions: string[] = ['', 'Yes', 'No'];
  // meterPanConditions: string[] = ['', 'Good', 'Fair', 'Need Repair', 'Not Installed'];
  // coRiserConditions: string[] = ['', 'Good', 'Fair', 'Need Repair', 'U.G. Feed'];
  batteryHeaterMatTypes: string[] = [''];
  // snowSheildOptions: string[] = ['', 'Yes', 'No', 'NA'];
  // seizureScrews: string[] = ['', 'Ok', 'Tightened'];
  // powerSupplyIDLegibilities: string[] = ['', 'Yes', 'No'];
  // lampCheckOptions: string[] = ['', 'Ok', 'Replace'];
  // checkCircuitBreakOptions: string[] = ['', 'Ok', 'Replace'];
  // cabinetInspections: string[] = ['', 'New', 'Good', 'Poor'];
  // cabinetLockOptions: string[] = ['', 'Ok', 'Missing', 'Replace'];
  // securityBarOptions: string[] = ['', 'Yes', 'No', 'NA'];
  // checkGroundConnections: string[] = ['', 'CATV', 'Missing', 'Repaired'];
  // batteryStringFuses: string[] = ['', 'Yes', 'No', 'NA'];
  // tamperInstalled: string[] = ['', 'Yes', 'No', 'NA'];
  // checkLAPs: string[] = ['', 'Ok', 'Replaced', 'None'];
  cabinetVendors: string[] = [];
  // batteryCapacities: string[] = ['', '1', '2', '3', '4', '6', '8', '12'];
  // operatingLights: string[] = ['', 'Ok', 'Need Red', 'Need Green'];
  // followUpAction: string[] = ['', 'Yes', 'No', 'Alpha'];
  surgeArrestorInputs: string[] = [''];
  outputSurgeArrestors: string[] = [''];
  // coaxOptions: string[] = ['', 'Yes', 'No', 'NA'];
  // ACIOptions: string[] = ['', 'Yes', 'No', 'NA'];
  // LRIOptions: string[] = ['', 'Yes', 'No', 'NA'];
  nextGenOptions: string[] = [];

  //Values for BatteryInfo
  numberofBatteries:string[]=[];
  /*numberofBatteries: string[] = ['',
    '0 String Of 0',
    '1 String Of 1',
    '1 String Of 2',
    '1 String Of 3',
    '2 Strings Of 3',
    '3 Strings Of 3',
    '1 String Of 4',
    '2 Strings Of 4',
    '3 Strings Of 4',
    '4 Strings Of 3',
    '4 Strings Of 4'];*/
  //batteriesReplaced: string[] = ['', 'Yes', 'No'];
  batteriesReplaced:string[]=[];
  //batterySeparatorPresent:string[]=[];
  //batterySeparatorPresent: string[] = ['', 'Yes', 'No'];
  batteryManagerModels: string[] = ['Embedded', 'External', 'None','Unknown'];
  batteryManufactureres: string[] = [''];
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
     }
     return true;
   }

   restrictSpecialPaste(event: ClipboardEvent) {
    let regexp = new RegExp('[^0-9/]');
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    let test = regexp.test(pastedText);
    let trimmedText = pastedText.replace(/[^0-9]/g, '');
    this.locationInfoForm.controls['zip'].patchValue(trimmedText);
    if (test) {
      event.preventDefault();
    }
  }


  openAddEntryDialog(val): void {
    this.powerSupplyNameNetConnectDialog = this.dialog.open(PowerSupplyNameNetConnectDialog, {
      autoFocus: false,
      data: {
        activeMac: this.activeMacAddresscopy,
        parent: this,
        powerSupplyName: ''
      },
      disableClose: val,
      maxHeight: '90vh',
      panelClass: 'my-centered-dialog',
      width: '700px'
    });

    this.powerSupplyNameNetConnectDialog.afterClosed().subscribe();
  }



  b64toBlob = (b64Data, contentType='application/octet-stream', sliceSize=512) => {
    const byteCharacters = atob(b64Data.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    const blobUrl = URL.createObjectURL(blob);

    return blob;
  }
 public psSingleFileUploadSubmit(file, uploadedId,name,activeMac,filearray) {
     this.openUploadDialog("Image Uploading..........");

    var uploadvalue = [];
    var categoryUploaded = [];
    var fileurl = this.b64toBlob(file);
    var categoryValue = uploadedId;
    let fileBlob = null;
    let fileName = null;
    let fileblobarray = [];
    if (fileurl !== null && fileurl !== undefined){
      fileName = name;
      this.submitFlag =true;
    }
    var blob = new Blob([fileurl], { type: 'multipart/form-data' });
    fileBlob = new File([blob], fileName);
    categoryUploaded.push(categoryValue);
    let uploadObj = {
      powerSupplyId: 0,
      powerSupplyName: null,
      macAddr: activeMac,
      //macAddr: '11',
      nodeId: null,
      createDate: "",
      latestImage: "null",
      fileName: "",
      contentType: "",
      category: categoryValue,
    };
    const uploadBlob = new Blob([JSON.stringify(uploadObj)], { type: 'multipart/form-data' });
    uploadvalue.push(uploadBlob);
    fileblobarray.push(fileBlob);
    var triageId = null;
    this.userDetails = JSON.parse(localStorage['user-details']);
    if ((this.userDetails.permissions.includes('{1091}'))) {
      //Comcast User or Inhouse
      this.permissionValue = true;
    }else{
      //Non Comcast User or Bp
      this.permissionValue = false;
    }
    if(!this.permissionValue){
      triageId = 0;
    }

    return new Promise((resolve, reject) => {

      this.powerSupplyService.uploadSdsImage('Create', triageId, fileblobarray, uploadvalue)
        .pipe(map(binaryData => binaryData))
        .subscribe(binaryData => {
          resolve(binaryData);
          const message = `PowerSupply Images Uploaded by: ${this.userName} at ${new Date().toISOString()} . Image categories are: ${categoryUploaded}`;
          const activity = 'PowerSupply Image Upload';
          this.commonService.loggerPost(message, activity, 3);
          //this.dialog.closeAll();

          this.openErrorDialog("Uploaded Successfully. Please Create Power Supply.");
          //this.openCreatedDialog("Image Uploaded Successfully");
          this.uploadDialog.close('OK')
        }, err => {
          reject(err);
          this.showProgressBar = false;
          this.openErrorDialog("Unable to Upload Images");
        });



    });
  }

  saveSfpTriage(localstorageSfp){
    this.powerSupplyService.savePowerSupplySfpTriage(localstorageSfp).subscribe(res => {
       this.showProgressBar = false;
       localStorage.removeItem('powerSupplySfp');
     },err => {
       this.showProgressBar = false;
     });
  }

  removePictureStorage(){
    localStorage.removeItem('cat1');
    localStorage.removeItem('cat2');
    localStorage.removeItem('cat3');
    localStorage.removeItem('cat4');
    localStorage.removeItem('cat5');
    localStorage.removeItem('cat6');
    localStorage.removeItem('cat7');
    localStorage.removeItem('cat8');
    localStorage.removeItem('cat9');
    localStorage.removeItem('cat10');
    localStorage.removeItem('cat11');
    localStorage.removeItem('cat12');
    localStorage.removeItem('filearray');
  }
  zoomIn(){

    if(this.zoomLevel < 1.4){
      this.zoomLevel += 0.1;
      this.applyZoom();
    }
  }
  zoomOut(){

    if(this.zoomLevel > 1){
      this.zoomLevel -= 0.1;
      this.applyZoom();
    }
  }
  applyZoom(){
    const videoElement = document.getElementById('qr-reader') as HTMLVideoElement;
    if(videoElement){
      videoElement.style.transform = `scale(${this.zoomLevel})`

    }
  }

}
